/* rfm-member-dashboard.js — generated 2026-07-17 from approved v12 prototypes. */
/* ===== desktop ===== */
(function(){
var ROOT=document.getElementsByClassName('rfmd')[0]; if(!ROOT) return;
ROOT.classList.add('rfm-ready');

/* ---- view switching ---- */
var navItems=ROOT.querySelectorAll('.nav-item[data-view]');
function go(view,writeHistory){
  navItems.forEach(function(n){n.classList.toggle('active',n.dataset.view===view)});
  ROOT.querySelectorAll('.view').forEach(function(v){v.classList.toggle('active',v.id==='view-'+view)});
  relocateRec(view);
  ROOT.querySelector('#main').scrollTop=0;
  if(writeHistory!==false&&location.hash!=='#'+view){history.pushState(null,'','#'+view);}
}
navItems.forEach(function(n){n.addEventListener('click',function(){go(n.dataset.view)})});
ROOT.querySelectorAll('[data-goto]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();go(a.dataset.goto)})});

/* ---- exposure batch 2026-08-06: rec block follows earn/redeem/tiers, ref rewritten per view ---- */
var REC_VIEWS={earn:1,redeem:1,tiers:1};
function relocateRec(view){
  var blk=ROOT.querySelector('#recBlock');if(!blk)return;
  if(view===undefined){var av=ROOT.querySelector('.view.active');view=av?av.id.replace('view-',''):'earn';}
  var target=REC_VIEWS[view]?view:'earn';
  var host=ROOT.querySelector('#view-'+target);
  if(host&&blk.parentNode!==host){host.appendChild(blk);}
  blk.querySelectorAll('a[href*="ref=member-dashboard-rec"]').forEach(function(a){
    a.href=a.href.replace(/ref=member-dashboard-rec[a-z-]*/,'ref=member-dashboard-rec-'+target);
  });
}
var _renderRecBase=renderRec;
renderRec=function(list){_renderRecBase(list);relocateRec();};
/* ---- home referral banner: reuses RFM_REFERRAL_URL, hooks independent of the earn card ---- */
(function(){
  var t=ROOT.querySelector('[data-refbanner-toggle]');if(!t)return;
  var panel=ROOT.querySelector('[data-refbanner-share]');
  var urlEl=ROOT.querySelector('[data-refbanner-url]');
  var copy=ROOT.querySelector('[data-refbanner-copy]');
  t.addEventListener('click',function(){
    if(!RFM_REFERRAL_URL)return;
    if(urlEl)urlEl.textContent=RFM_REFERRAL_URL;
    if(panel)panel.hidden=!panel.hidden;
  });
  if(copy)copy.addEventListener('click',function(){
    if(!RFM_REFERRAL_URL)return;
    try{navigator.clipboard.writeText(RFM_REFERRAL_URL).catch(function(){});}catch(e){}
    copy.textContent='Copied!';setTimeout(function(){copy.textContent='Copy invite link';},1600);
  });
})();

/* ---- redeem cash slider (v0.4 bands: 300-500→$99.99 | 501-1500→$299.99 | 1501-3000→$799.99) ---- */
/* RFM_RIVO_ADAPTER_V1 — proven store paths only; no Merchant API. */
var RFM_RIVO=(function(){
  var TIER_MAP={
    Rookie:{tierX:1,infinityX:2},
    Grinder:{tierX:1,infinityX:2},
    Beast:{tierX:1.25,infinityX:2.5},
    Legend:{tierX:1.5,infinityX:3}
  };
  function flag(search,name){return new RegExp('(?:^|[?&])'+name+'=1(?:&|$)').test(search||'');}
  function mode(customer,loc){
    loc=loc||{};
    if(flag(loc.search,'gate')) return 'guest';
    if(loc.protocol==='file:'||flag(loc.search,'demo')) return 'demo';
    return customer?'real':'guest';
  }
  function finite(value){
    var number=typeof value==='number'?value:Number(value);
    return Number.isFinite(number)?number:null;
  }
  function tierName(value,optional){
    if(value===null||value===undefined||String(value).trim()==='') return null;
    var raw=String(value).trim().toLowerCase();
    var names=Object.keys(TIER_MAP);
    for(var i=0;i<names.length;i++) if(names[i].toLowerCase()===raw) return names[i];
    if(optional) return null;
    var error=new Error('Unsupported Rivo tier name'); error.name='RivoSchemaError'; throw error;
  }
  function birthMonth(value){
    if(typeof value!=='string'||!value.trim()) return null;
    var raw=value.trim();
    var match=raw.match(/^\d{4}-(\d{2})-(\d{2})/);
    if(match){var month=Number(match[1]);return month>=1&&month<=12?month:null;}
    /* Rivo's legacy widget stores birthdays as MM-DD or M-D (no year); Safari parses "07-09" as year 7 / month 9 via new Date, so match it explicitly */
    var legacy=raw.match(/^(\d{1,2})-(\d{1,2})$/);
    if(legacy){var legacyMonth=Number(legacy[1]);return legacyMonth>=1&&legacyMonth<=12?legacyMonth:null;}
    var parsed=new Date(raw);
    return Number.isFinite(parsed.getTime())?parsed.getUTCMonth()+1:null;
  }
  function birthDay(value){
    if(typeof value!=='string'||!value.trim()) return null;
    var raw=value.trim(),month=birthMonth(raw),day;
    var iso=raw.match(/^\d{4}-\d{2}-(\d{2})(?:$|[T\s])/);
    var legacy=raw.match(/^\d{1,2}-(\d{1,2})$/);
    if(iso||legacy) day=Number((iso||legacy)[1]);
    else {var parsed=new Date(raw);day=Number.isFinite(parsed.getTime())?parsed.getUTCDate():null;}
    var maxDay=month?[31,29,31,30,31,30,31,31,30,31,30,31][month-1]:0;
    return Number.isInteger(day)&&day>=1&&day<=maxDay?day:null;
  }
  function birthdayReminder(details,now){
    var month=details&&details.birthMonth,day=details&&details.birthDay;
    if(!Number.isInteger(month)||month<1||month>12||!Number.isInteger(day)||day<1||day>[31,29,31,30,31,30,31,31,30,31,30,31][month-1]) return false;
    now=now||new Date();
    if(!Number.isFinite(now.getTime())) return false;
    /* Compare local calendar dates as UTC day numbers so DST cannot shorten the window. */
    var year=now.getFullYear(),today=Date.UTC(year,now.getMonth(),now.getDate());
    for(var y=year-1;y<=year+1;y++){
      /* Feb 29 uses February's last day in non-leap years for this reminder only. */
      var anniversary=Date.UTC(y,month-1,Math.min(day,new Date(Date.UTC(y,month,0)).getUTCDate()));
      if(Math.abs(anniversary-today)<=7*86400000) return true;
    }
    return false;
  }
  function httpUrl(value){
    if(typeof value!=='string'||!value.trim()) return null;
    try {
      var parsed=new URL(value,'https://www.ritfitsports.com');
      return parsed.protocol==='https:'||parsed.protocol==='http:'?parsed.href:null;
    } catch (error) { return null; }
  }
  function normalize(details,vip,referrals){
    details=details&&typeof details==='object'?details:{};
    vip=vip&&typeof vip==='object'?vip:{};
    referrals=referrals&&typeof referrals==='object'?referrals:{};
    var rawTier=vip.tier&&vip.tier.name;
    var tier=tierName(rawTier,false);
    var map=tier?TIER_MAP[tier]:null;
    var highest=vip.highest_tier===true||tier==='Legend';
    var next=highest?null:tierName(vip.next_tier&&vip.next_tier.name,true);
    var balance=finite(details.points_tally);
    if(balance!==null) balance=Math.max(0,Math.floor(balance));
    var nextAt=highest?null:finite(vip.next_tier&&vip.next_tier.threshold);
    if(nextAt!==null) nextAt=Math.max(0,Math.floor(nextAt));
    var expiry=typeof details.points_expiry==='string'&&details.points_expiry.trim()?details.points_expiry.trim():null;
    var toEarn=highest?null:finite(vip.next_tier&&vip.next_tier.to_spend_or_earn);
    if(toEarn!==null) toEarn=Math.max(0,Math.ceil(toEarn));
    var progressPct=highest?null:finite(vip.percentage_to_next_tier);
    return {
      balance:balance,
      tier:tier,
      tierX:map?map.tierX:null,
      nextTier:next,
      nextTierAt:nextAt,
      toEarn:toEarn,
      progressPct:progressPct,
      infinityX:map?map.infinityX:null,
      birthMonth:birthMonth(details.dob),
      birthDay:birthDay(details.dob),
      expiring:{pts:null,date:expiry},
      referralUrl:httpUrl(referrals.url)||httpUrl(details.referral_url)
    };
  }
  function hasApi(api){
    return !!api&&['getCustomerDetails','getCustomerVipTier','getCustomerReferrals'].every(function(name){return typeof api[name]==='function';});
  }
  function waitForApi(win,doc,timeoutMs){
    if(hasApi(win&&win.RivoJS)) return Promise.resolve(win.RivoJS);
    return new Promise(function(resolve,reject){
      var done=false;
      function cleanup(){
        if(doc&&typeof doc.removeEventListener==='function') doc.removeEventListener('rivo-js-loaded',ready);
        clearTimeout(timer);
      }
      function ready(){
        if(done||!hasApi(win&&win.RivoJS)) return;
        done=true; cleanup(); resolve(win.RivoJS);
      }
      if(doc&&typeof doc.addEventListener==='function') doc.addEventListener('rivo-js-loaded',ready);
      var timer=setTimeout(function(){
        if(done) return; done=true; cleanup();
        var error=new Error('RivoJS did not become ready'); error.name='RivoTimeoutError'; reject(error);
      },Math.max(1,timeoutMs||10000));
    });
  }
  function fetchAll(api){
    return Promise.all([
      api.getCustomerDetails(),
      api.getCustomerVipTier(),
      api.getCustomerReferrals()
    ]);
  }
  async function bootstrap(options){
    options=options||{};
    var currentMode=mode(options.customer,options.location||{});
    var onState=typeof options.onState==='function'?options.onState:function(){};
    if(currentMode==='guest') return null;
    if(currentMode==='demo') return options.demo||null;
    onState('loading');
    try {
      var api=await waitForApi(options.window||{},options.document||{},options.timeoutMs||10000);
      var payloads=await fetchAll(api);
      return normalize(payloads[0],payloads[1],payloads[2]);
    } catch (error) {
      onState('error',error);
      throw error;
    }
  }
  return {mode:mode,normalize:normalize,birthdayReminder:birthdayReminder,waitForApi:waitForApi,fetchAll:fetchAll,bootstrap:bootstrap,tierMap:TIER_MAP};
})();
/* ---- member + loyalty data boundary (Task 4) ---- */
var RFM=window.RFM_CUSTOMER||null;
var RFM_MODE=RFM_RIVO.mode(RFM,location);
var IS_GATED=RFM_MODE==='guest';
var RFM_DEMO={name:'Alex',balance:1240,tier:'Rookie',tierX:1,nextTier:'Grinder',nextTierAt:1500,toEarn:260,progressPct:82.7,infinityX:2,birthMonth:7,expiring:{pts:200,date:'Sep 12, 2026'},referralUrl:'https://example.com/demo-referral',vouchers:[{code:'BAL-DEMO4F2A9C01',name:'$170 off coupon',kind:'cash',amount:170,min_cart:null,applied_at:'2026-07-18T12:00:00Z',expires_at:null},{code:'BAL-DEMO7B3E5D02',name:'Free Crystal Plate',kind:'gear',amount:null,min_cart:null,applied_at:'2026-07-05T12:00:00Z',expires_at:'2026-08-30T00:00:00Z'}]};
var RFM_LOYALTY=null;
var RFM_SHELL=ROOT.querySelector('[data-rivo-shell]');
var CURRENT_TIER_INDEX=-1;
var RFM_BOOT_TOKEN=0;
/* Infinity Day = the 8th (ET). ?d8=1 forces preview of the Infinity state. */
var IS_D8=/[?&]d8=1/.test(location.search)||new Date().toLocaleDateString('en-US',{timeZone:'America/New_York',day:'numeric'})==='8';
/* Member Month Aug 2026 (ET). ?mm=pre / ?mm=on force preview; year-locked so it cannot resurface in 2027. */
var ET_TODAY=new Date().toLocaleDateString('en-CA',{timeZone:'America/New_York'});
var MM_STATE=/[?&]mm=pre\b/.test(location.search)?'pre':/[?&]mm=on\b/.test(location.search)?'on':(ET_TODAY>='2026-08-05'&&ET_TODAY<='2026-08-07')?'pre':(ET_TODAY>='2026-08-08'&&ET_TODAY<='2026-08-31')?'on':null;
/* Flash Day draw dates (ET), per the approved MM V2 plan. ?flash=1 forces preview. */
var IS_FLASH=/[?&]flash=1/.test(location.search)||ET_TODAY==='2026-08-08'||ET_TODAY==='2026-08-18'||ET_TODAY==='2026-08-28';
/* MM member-exclusive gift notice window (Aug 2026, year-locked). ?mmgift=1 forces preview. */
var IS_MMGIFT=/[?&]mmgift=1/.test(location.search)||(ET_TODAY>='2026-08-08'&&ET_TODAY<='2026-08-31');
/* ?bday=1 previews the birthday reminder; normal display is D-7 through D+7 in the customer's local calendar. */
var IS_BDAY_PREVIEW=/[?&]bday=1/.test(location.search);
if(IS_GATED){ROOT.classList.add('rfm-gated');ROOT.querySelector('.gate-card').hidden=false;}
if(RFM){var nm=RFM.firstName||'Member';
  ROOT.querySelectorAll('[data-rfm="firstName"]').forEach(function(e){e.textContent=nm});
  ROOT.querySelectorAll('[data-rfm="email"]').forEach(function(e){e.textContent=RFM.email||''});
}

/* ---- orders list (v9) ---- */
var ORDERS_DEMO=[{name:'#RF-20418',date:'Jun 24, 2026',total:'$248.00',status:'Fulfilled',url:'#'},
                 {name:'#RF-19876',date:'May 12, 2026',total:'$89.99',status:'Fulfilled',url:'#'}];
(function(){
  var host=ROOT.querySelector('#ordersList'); if(!host) return;
  var list=RFM?(RFM.orders||[]):(RFM_MODE==='demo'?ORDERS_DEMO:[]);
  if(!list.length){host.innerHTML='<div class="orders-empty">No orders yet — your history will appear here.<br><a class="btn btn-red" href="https://www.ritfitsports.com/?ref=member-dashboard-orders">Shop Now</a></div>';return;}
  host.innerHTML=list.map(function(o){return '<div class="orow"><span class="oid">'+o.name+'</span><span class="od">'+o.date+'</span><span class="ot">'+o.total+'</span><span class="os">'+(o.status||'')+'</span>'+(o.url&&o.url!=='#'?'<a class="ov" href="'+o.url+'">View</a>':'')+'</div>'}).join('');
})();
var BAL=null;
var slider=ROOT.querySelector('#cashSlider');
function band(p){ if(p<=500) return '$99.99'; if(p<=1500) return '$299.99'; return '$799.99'; }
function updCash(){
  var cashPts=ROOT.querySelector('#cashPts'),cashVal=ROOT.querySelector('#cashVal'),cashTier=ROOT.querySelector('#cashTier');
  if(BAL===null||BAL<300){
    slider.disabled=true; slider.min=300; slider.max=300; slider.value=300;
    cashPts.textContent='Not available'; cashVal.textContent='—';
    cashTier.textContent=BAL===null?'Points balance is unavailable.':'Earn at least 300 points to redeem.';
    slider.style.setProperty('--pct','0%'); return;
  }
  slider.disabled=false;
  var p=+slider.value;
  cashPts.textContent=p.toLocaleString()+' pts';
  cashVal.textContent='$'+(p*0.05).toFixed(2)+' Off';
  cashTier.innerHTML='Applies to orders over <b>'+band(p)+'</b> · voucher valid 90 days';
  slider.style.setProperty('--pct',((p-300)/Math.max(1,(+slider.max||300)-300)*100)+'%');
}
slider.addEventListener('input',function(){updCash();refreshCashCta();}); updCash();

/* ---- gear grid ---- */
var REDEEM=[{"name": "Water Bottle", "points": 624, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-57f355ca-jpg')}, {"name": "RitFit Sports Cap", "points": 624, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-362883d3-jpg')}, {"name": "Sports Towel", "points": 374, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-ffe39cc6-jpg')}, {"name": "Non-Slip Yoga Mat", "points": 749, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-4207876c-jpg')}, {"name": "Crystal Plate", "points": 624, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-e0896741-jpg')}, {"name": "Preacher Curl Pad", "points": 749, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-f8fae7c4-jpg')}, {"name": "Dumbbells 55LB Pair", "points": 3249, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-e1852c1f-jpg')}];
var grid=ROOT.querySelector('#gearGrid');
var GEAR_LIVE=[];
function gearImageFor(name){
  var key=String(name||'').toLowerCase().replace(/^free\s+/,'').trim();
  for(var i=0;i<REDEEM.length;i++){
    var demoKey=REDEEM[i].name.toLowerCase();
    if(key.indexOf(demoKey)!==-1||demoKey.indexOf(key)!==-1)return REDEEM[i].img;
  }
  return null;
}
function renderGear(){
  grid.innerHTML='';
  if(BAL===null){grid.innerHTML='<div class="orders-empty">Points balance is unavailable.</div>';return;}
  var isDemo=RFM_MODE==='demo';
  if(!isDemo){
    if(!RFM_REWARDS.loaded){grid.innerHTML='<div class="orders-empty">Loading rewards…</div>';return;}
    if(RFM_REWARDS.error||!rmApi()){grid.innerHTML='<div class="orders-empty">We could not load the rewards catalog right now. Please refresh to try again.</div>';return;}
    if(!RFM_REWARDS.gear.length){grid.innerHTML='<div class="orders-empty">No free gear rewards are available right now.</div>';return;}
  }
  GEAR_LIVE=isDemo
    ?REDEEM.map(function(p){return {id:null,name:p.name,points:p.points,img:p.img};})
    :RFM_REWARDS.gear.map(function(r){return {id:r.id,name:r.name.replace(/^Free\s+/i,''),points:r.points,img:r.image||gearImageFor(r.name)};});
  GEAR_LIVE.forEach(function(p,idx){
    var can=p.points<=BAL;
    var el=document.createElement('div');
    el.className='card hov gcard';
    el.innerHTML=(p.img?'<img src="'+p.img+'" alt="">':'<div class="gcard-noimg" aria-hidden="true">RitFit</div>')+
      '<div class="n"></div><div class="p">'+p.points.toLocaleString()+' pts</div>'+
      (can?'<button type="button" data-rm-gear-idx="'+idx+'">Redeem</button>':'<button type="button" disabled>Need '+(p.points-BAL).toLocaleString()+' more</button>');
    el.querySelector('.n').textContent=p.name;
    grid.appendChild(el);
  });
}
grid.addEventListener('click',function(event){
  var btn=event.target&&event.target.closest?event.target.closest('[data-rm-gear-idx]'):null;
  if(!btn||btn.disabled)return;
  var item=GEAR_LIVE[+btn.getAttribute('data-rm-gear-idx')];
  if(item)openRedeemModal({kind:'gear',reward:item});
});

/* ---- recommended for you (v9: data-driven renderer + tier-crossing nudge + Infinity Day rate) ----
   Production wiring (Codex batch): Liquid customer.orders seed -> /recommendations/products.json
   (intent=complementary, fallback related; that endpoint returns prices in CENTS) -> filter
   owned / same product_type as seed / unavailable / price-cap -> call renderRec(cards).
   renderRec owns sorting + Infinity math; the data source never needs to know.
   REC_DEFAULT = curated live-catalog facts (2026-07-16); also the no-history / fetch-failure fallback. */
var TIER_X=null;
var REC_DEFAULT=[
 {name:'GATOR 1600LB Adjustable Bench', price:359.99, from:false,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/img_v3_02rq_7d851ab7-cead-49e4-ac81-1ecc07218f3g.jpg?v=1762506572&width=280',
  url:'https://www.ritfitsports.com/products/ritfit-gator-adjustable-weight-bench?ref=member-dashboard-rec'},
 {name:'Fleck Olympic Bumper Plates', price:99.99, from:true,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/15_88e462e0-3c01-4a66-84ab-31d93cfd3640.jpg?v=1712481220&width=280',
  url:'https://www.ritfitsports.com/products/ritfit-fleck-bumper-plates-2-inch-olympic-rubber-weight-plates?ref=member-dashboard-rec'},
 {name:'AT04 Leg Press Foot Plate', price:99.99, from:false,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/173972f8ba4bc6cdcfde6ccfdf127a97.jpg?v=1755138917&width=280',
  url:'https://www.ritfitsports.com/products/ritfit-foot-plate-for-leg-press-at04?ref=member-dashboard-rec'},
 {name:'Decagon PEV Dumbbells', price:25.99, from:true,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/2_3.webp?v=1774332801&width=280',
  url:'https://www.ritfitsports.com/products/toughfit-decagon-shape-dumbbells-pev?ref=member-dashboard-rec'}
];
/* 登录但无订单 → 首单旗舰位（用户 7/17 拍板：推最希望首购的明星/旗舰主机，价格梯覆盖入门→旗舰；
   不走 accept() 价格帽——该帽只约束"已购配件推荐"分支）。数据 = live catalog 2026-07-17。 */
var REC_FIRST_ORDER=[
 {name:"M1 PRO Multi-Functional Smith Machine", price:1299.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/1_dd5cda42-f5b4-47e2-b007-cc5c1f219fc7.jpg?v=1759039529&width=280",
  url:'https://www.ritfitsports.com/products/m1-multi-functional-home-gym-smith-machine?ref=member-dashboard-rec'},
 {name:"M3 Smith Machine with Cable Crossover", price:2999.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/ritfit-m3-power-rack-smith-cable-crossover-black-silver-grey-bg.webp?v=1778134874&width=280",
  url:'https://www.ritfitsports.com/products/m3-power-rack-cable-crossover-smith-machine?ref=member-dashboard-rec'},
 {name:"M1 Smith Machine with Cable Crossover", price:1069.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/6_2.webp?v=1774332360&width=280",
  url:'https://www.ritfitsports.com/products/ritfit-m1-smith-machine-with-cable-crossover-system-for-home-gym?ref=member-dashboard-rec'},
 {name:"P3 Power Cage with Smooth Cable System", price:719.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/P3_Black_gray_background.jpg?v=1773994914&width=280",
  url:'https://www.ritfitsports.com/products/ritfit-p3-1200lbs-power-cage-with-smooth-cable-system?ref=member-dashboard-rec'}
];
var rg=ROOT.querySelector('#recGrid');
function renderRec(list){
  var D=RFM_LOYALTY;
  if(!D||D.balance===null||D.tierX===null){rg.innerHTML='<div class="orders-empty">Recommendations require current loyalty data.</div>';return;}
  var gap=D.nextTier?Math.max(0,D.nextTierAt-D.balance):0;
  var needSpend=(D.nextTier&&gap>0)?gap/D.tierX:Infinity;
  var mult=IS_D8?D.infinityX:1;
  rg.innerHTML='';
  list.slice().sort(function(a,b){return (b.price>=needSpend)-(a.price>=needSpend)})
  .forEach(function(p){
    var pts=Math.floor(p.price*D.tierX*mult);
    var el=document.createElement('div');
    el.className='card hov rcard';
    el.innerHTML='<img class="rimg" src="'+p.img+'" alt="'+p.name+'" loading="lazy">'+
      '<div class="n">'+p.name+'</div>'+
      '<div class="prow"><div class="price">'+(p.from?'<small>From </small>':'')+'$'+p.price.toFixed(2)+'</div><span class="ppts">Earn +'+pts.toLocaleString()+' pts'+(mult>1?' ('+D.infinityX+'\u00d7)':'')+'</span></div>'+
      '<a class="rbtn" href="'+p.url+'" target="_blank" rel="noopener">View Product</a>';
    rg.appendChild(el);
  });
}
/* rendered after loyalty bootstrap */

/* ---- RFM_REAL_ACTIONS_V1: live rewards catalog + real RivoJS redemption ---- */
var RFM_REWARDS={loaded:false,cash:[],gear:[],error:null};
var RM_BUSY=false;
var RM_CTX=null;
var CASH_BANDS=[
  {name:'Iron',min:300,max:500,order:'$99.99'},
  {name:'Steel',min:501,max:1500,order:'$299.99'},
  {name:'Titanium',min:1501,max:3000,order:'$799.99'}
];
function rmApi(){var a=window.RivoJS;return a&&typeof a.redeemReward==='function'?a:null;}
function rmListApi(){var a=window.RivoJS;return a&&typeof a.getShopRewards==='function'?a:null;}
function rmNum(v){var n=typeof v==='number'?v:Number(v);return Number.isFinite(n)?n:null;}
function rmStr(v){return typeof v==='string'&&v.trim()?v.trim():null;}
function normalizeReward(r){
  if(!r||typeof r!=='object')return null;
  var id=r.id===undefined||r.id===null?null:String(r.id);
  var name=rmStr(r.name)||rmStr(r.title);
  if(r.enabled===false||!id||!name)return null;
  var type=(rmStr(r.reward_type)||rmStr(r.type)||'').toLowerCase();
  return {id:id,name:name,type:type,points:rmNum(r.points_amount),image:rmStr(r.icon_url)||rmStr(r.image_url)};
}
function classifyRewards(list){
  var cash=[],gear=[];
  (Array.isArray(list)?list:[]).forEach(function(item){
    var reward=normalizeReward(item); if(!reward)return;
    if(/^(iron|steel|titanium) reward/i.test(reward.name)){cash.push(reward);return;}
    if(reward.type==='free_product'&&reward.points!==null&&reward.points>0)gear.push(reward);
  });
  gear.sort(function(a,b){return a.points-b.points});
  return {cash:cash,gear:gear};
}
function loadShopRewards(){
  if(RFM_MODE!=='real')return;
  var api=rmListApi();
  if(!api){RFM_REWARDS.loaded=true;RFM_REWARDS.error='unsupported';refreshCashCta();renderGear();return;}
  api.getShopRewards().then(function(list){
    var grouped=classifyRewards(list&&list.rewards?list.rewards:list);
    RFM_REWARDS={loaded:true,error:null,cash:grouped.cash,gear:grouped.gear};
    refreshCashCta();renderGear();
  }).catch(function(){
    RFM_REWARDS.loaded=true;RFM_REWARDS.error='load';
    refreshCashCta();renderGear();
  });
}
function cashBandFor(points){
  for(var i=0;i<CASH_BANDS.length;i++){if(points>=CASH_BANDS[i].min&&points<=CASH_BANDS[i].max)return CASH_BANDS[i];}
  return null;
}
function cashRewardFor(band){
  if(!band)return null;
  for(var i=0;i<RFM_REWARDS.cash.length;i++){
    if(RFM_REWARDS.cash[i].name.toLowerCase().indexOf(band.name.toLowerCase())===0)return RFM_REWARDS.cash[i];
  }
  return null;
}
function refreshCashCta(){
  var btn=ROOT.querySelector('[data-rm-cash-btn]'); if(!btn)return;
  var note=ROOT.querySelector('[data-rm-cash-note]');
  function say(text){if(note){note.hidden=!text;if(text)note.textContent=text;}}
  if(RFM_MODE==='demo'){btn.disabled=false;say('');return;}
  if(RFM_MODE!=='real'||BAL===null||BAL<300){btn.disabled=true;say('');return;}
  if(!RFM_REWARDS.loaded){btn.disabled=true;say('');return;}
  var band=cashBandFor(+slider.value||0);
  var ok=!!rmApi()&&!RFM_REWARDS.error&&!!cashRewardFor(band);
  btn.disabled=!ok;
  if(ok){say('');}
  else if(RFM_REWARDS.error==='unsupported'){say('Cash redemption is temporarily unavailable here. Please try again later.');}
  else if(RFM_REWARDS.error){say('We could not load redemption options. Refresh to try again.');}
  else{say('Cash redemption is temporarily unavailable for this amount.');}
}
function rmStepShow(step){
  ROOT.querySelectorAll('[data-rm-step]').forEach(function(el){el.hidden=el.getAttribute('data-rm-step')!==step;});
}
function openRedeemModal(ctx){
  var overlay=ROOT.querySelector('[data-rm-overlay]'); if(!overlay)return;
  RM_CTX=ctx;RM_BUSY=false;
  var copyEl=ROOT.querySelector('[data-rm-copy]');
  var fineEl=ROOT.querySelector('[data-rm-fine]');
  var confirmBtn=ROOT.querySelector('[data-rm-confirm]');
  if(confirmBtn)confirmBtn.disabled=false;
  if(RFM_MODE==='demo'){
    if(copyEl)copyEl.textContent=ctx.kind==='cash'
      ?'Demo preview — redeeming '+ctx.points.toLocaleString()+' points for $'+(ctx.points*0.05).toFixed(2)+' off.'
      :'Demo preview — redeeming '+ctx.reward.points.toLocaleString()+' points for '+ctx.reward.name+'.';
    if(fineEl)fineEl.textContent='Redemption is disabled in demo mode.';
    if(confirmBtn)confirmBtn.disabled=true;
  } else if(ctx.kind==='cash'){
    var band=cashBandFor(ctx.points);
    if(copyEl)copyEl.textContent='Redeem '+ctx.points.toLocaleString()+' points for a $'+(ctx.points*0.05).toFixed(2)+' off voucher?';
    if(fineEl)fineEl.textContent='Works on orders over '+(band?band.order:'—')+' · voucher valid 90 days · can\'t combine with promo codes.';
  } else {
    if(copyEl)copyEl.textContent='Redeem '+ctx.reward.points.toLocaleString()+' points for '+ctx.reward.name+'?';
    if(fineEl)fineEl.textContent='You\'ll receive a reward code to claim this gear at checkout.';
  }
  rmStepShow('confirm');
  overlay.hidden=false;
}
function closeRedeemModal(){
  var overlay=ROOT.querySelector('[data-rm-overlay]');
  if(overlay)overlay.hidden=true;
  RM_CTX=null;RM_BUSY=false;
}
function extractRedeemCode(data){
  function walk(node,depth){
    if(!node||typeof node!=='object'||depth>4)return null;
    var keys=['code','discount_code','coupon_code','voucher_code','reward_code'];
    for(var i=0;i<keys.length;i++){
      var value=node[keys[i]];
      if(typeof value==='string'&&value.trim())return value.trim();
    }
    for(var key in node){
      if(Object.prototype.hasOwnProperty.call(node,key)){
        var found=walk(node[key],depth+1);
        if(found)return found;
      }
    }
    return null;
  }
  return walk(data,0);
}
function refreshLoyaltyAfterRedeem(){
  if(RFM_MODE!=='real')return;
  RFM_RIVO.bootstrap({customer:RFM,location:location,window:window,document:document,timeoutMs:10000,demo:RFM_DEMO,onState:function(){}})
    .then(function(data){if(data)renderLoyalty(data);})
    .catch(function(){});
}
function performRedeem(){
  if(RM_BUSY||!RM_CTX||RFM_MODE!=='real')return;
  var api=rmApi();
  var errEl=ROOT.querySelector('[data-rm-error]');
  if(!api){if(errEl)errEl.textContent='Redemption is temporarily unavailable. Please try again later.';rmStepShow('error');return;}
  var rewardId=null,payload;
  if(RM_CTX.kind==='cash'){
    var band=cashBandFor(RM_CTX.points),reward=cashRewardFor(band);
    if(!reward){if(errEl)errEl.textContent='This amount is temporarily unavailable. Please adjust the slider and try again.';rmStepShow('error');return;}
    rewardId=reward.id;payload={points:RM_CTX.points};
  } else {
    rewardId=RM_CTX.reward.id;
  }
  RM_BUSY=true;rmStepShow('busy');
  Promise.resolve(payload===undefined?api.redeemReward(rewardId):api.redeemReward(rewardId,payload)).then(function(data){
    RM_BUSY=false;
    var code=extractRedeemCode(data);
    if(!code){
      if(errEl)errEl.textContent='We could not confirm this redemption. Please refresh the page, then check your points balance and Your vouchers before trying again.';
      rmStepShow('error');
      try{document.dispatchEvent(new CustomEvent('rfm-loyalty-refresh'))}catch(e){}
      return;
    }
    var codeWrap=ROOT.querySelector('[data-rm-code]');
    var codeValue=ROOT.querySelector('[data-rm-code-value]');
    var doneCopy=ROOT.querySelector('[data-rm-done-copy]');
    var doneFine=ROOT.querySelector('[data-rm-done-fine]');
    if(code&&codeWrap&&codeValue){codeValue.textContent=code;codeWrap.hidden=false;}
    else if(codeWrap){codeWrap.hidden=true;}
    if(doneCopy)doneCopy.textContent=RM_CTX&&RM_CTX.kind==='cash'
      ?'Your $'+(RM_CTX.points*0.05).toFixed(2)+' off voucher is ready.'
      :'Your reward is ready.';
    if(doneFine)doneFine.textContent='Apply this code at checkout. You can also find it anytime under Redeem \u2192 Your vouchers, and in your confirmation email.';
    rmStepShow('done');
    if(code&&window.RFM_VOUCHER_PUSH)window.RFM_VOUCHER_PUSH({code:code,name:(RM_CTX&&RM_CTX.kind==='cash')?('$'+(RM_CTX.points*0.05).toFixed(2).replace(/\.00$/,'')+' off coupon'):((RM_CTX&&RM_CTX.reward&&RM_CTX.reward.name)||'Reward voucher'),kind:(RM_CTX&&RM_CTX.kind==='cash')?'cash':'gear',amount:(RM_CTX&&RM_CTX.kind==='cash')?RM_CTX.points*0.05:null,min_cart:(function(){if(!RM_CTX||RM_CTX.kind!=='cash')return null;var b=cashBandFor(RM_CTX.points);return b?parseFloat(String(b.order).replace('$',''))||null:null;})(),applied_at:new Date().toISOString(),expires_at:(RM_CTX&&RM_CTX.kind==='cash')?new Date(Date.now()+90*86400000).toISOString():null});
    try{document.dispatchEvent(new CustomEvent('rfm-loyalty-refresh'))}catch(e){}
  }).catch(function(error){
    RM_BUSY=false;
    var message=error&&error.message?String(error.message):'';
    if(errEl)errEl.textContent=message&&message.length<160
      ?message
      :'Something went wrong and the redemption may not have completed. Please check your points balance before trying again.';
    rmStepShow('error');
  });
}
(function(){
  var overlay=ROOT.querySelector('[data-rm-overlay]'); if(!overlay)return;
  var cashBtn=ROOT.querySelector('[data-rm-cash-btn]');
  if(cashBtn)cashBtn.addEventListener('click',function(){
    if(RFM_MODE==='demo'){openRedeemModal({kind:'cash',points:+slider.value||600});return;}
    if(RFM_MODE!=='real'||BAL===null||BAL<300)return;
    var points=+slider.value;
    var band=cashBandFor(points);
    if(!band||!cashRewardFor(band))return;
    openRedeemModal({kind:'cash',points:points});
  });
  overlay.addEventListener('click',function(event){if(event.target===overlay&&!RM_BUSY)closeRedeemModal();});
  [['[data-rm-cancel]'],['[data-rm-close]'],['[data-rm-close-2]']].forEach(function(pair){
    var el=ROOT.querySelector(pair[0]);
    if(el)el.addEventListener('click',closeRedeemModal);
  });
  var confirmBtn=ROOT.querySelector('[data-rm-confirm]');
  if(confirmBtn)confirmBtn.addEventListener('click',performRedeem);
  var retryBtn=ROOT.querySelector('[data-rm-retry]');
  if(retryBtn)retryBtn.addEventListener('click',function(){rmStepShow('confirm');});
  var copyBtn=ROOT.querySelector('[data-rm-copy-btn]');
  if(copyBtn)copyBtn.addEventListener('click',function(){
    var value=ROOT.querySelector('[data-rm-code-value]');
    if(value&&navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(value.textContent).then(function(){
        copyBtn.textContent='Copied!';
        setTimeout(function(){copyBtn.textContent='Copy';},1500);
      }).catch(function(){});
    }
  });
})();

/* ---- RFM_REF_SHARE_V2: in-dashboard referral link reveal + copy ---- */
var RFM_REFERRAL_URL=null;
(function(){
  var trigger=ROOT.querySelector('[data-rivo-referral]');
  var panel=ROOT.querySelector('[data-ref-share]');
  var copyButton=ROOT.querySelector('[data-ref-copy]');
  if(trigger)trigger.addEventListener('click',function(event){
    event.preventDefault();
    if(!RFM_REFERRAL_URL||!panel)return;
    panel.hidden=false;
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(RFM_REFERRAL_URL).then(function(){
        if(copyButton){copyButton.textContent='Copied!';setTimeout(function(){copyButton.textContent='Copy';},1500);}
      }).catch(function(){});
    }
  });
  if(copyButton)copyButton.addEventListener('click',function(){
    if(!RFM_REFERRAL_URL)return;
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(RFM_REFERRAL_URL).then(function(){
        copyButton.textContent='Copied!';
        setTimeout(function(){copyButton.textContent='Copy';},1500);
      }).catch(function(){});
    }
  });
})();

/* ---- RFM_VOUCHERS_V1: redeemed voucher visibility (metafield-fed, sync-lagged) ---- */
var RFM_VOUCHER_STORE='rfm-vouchers-local:'+((RFM&&RFM.email)||'demo');
function rfmVoucherLocal(){try{return JSON.parse(localStorage.getItem(RFM_VOUCHER_STORE)||'[]')}catch(e){return []}}
function rfmVoucherList(){
  if(IS_GATED)return [];
  var base=RFM_MODE==='demo'?((RFM_DEMO&&RFM_DEMO.vouchers)||[]):((window.RFM_VOUCHERS&&window.RFM_VOUCHERS.vouchers)||[]);
  var merged=base.slice();
  rfmVoucherLocal().forEach(function(v){if(v&&v.code&&!merged.some(function(b){return b.code===v.code}))merged.push(v)});
  var now=new Date().toISOString();
  return merged.filter(function(v){return v&&v.code&&(!v.expires_at||v.expires_at>now)}).sort(function(a,b){return (a.applied_at||'')<(b.applied_at||'')?1:-1});
}
window.RFM_VOUCHER_PUSH=function(v){
  if(!v||!v.code)return;
  var list=rfmVoucherLocal();
  if(!list.some(function(b){return b&&b.code===v.code})){list.push(v);try{localStorage.setItem(RFM_VOUCHER_STORE,JSON.stringify(list.slice(-20)))}catch(e){}}
  try{document.dispatchEvent(new CustomEvent('rfm-vouchers-updated'))}catch(e){}
};
function renderVouchers(){
  var list=rfmVoucherList();
  var block=ROOT.querySelector('#voucherBlock'),host=ROOT.querySelector('#voucherList');
  if(block&&host){
    block.hidden=!list.length;
    host.innerHTML='';
    list.forEach(function(v){
      var row=document.createElement('div');row.className='vrow';
      row.innerHTML='<div class="vinfo"><div class="vname"></div><div class="vmeta"></div></div><code class="vcode"></code><button type="button" class="vcopy">Copy</button>';
      var meta=[];
      if(v.expires_at)meta.push('valid through '+formatRivoDate(v.expires_at));
      if(v.min_cart)meta.push('orders over $'+Number(v.min_cart).toFixed(2));
      meta.push('apply at checkout');
      row.querySelector('.vname').textContent=v.name||'Reward voucher';
      row.querySelector('.vmeta').textContent=meta.join(' · ');
      row.querySelector('.vcode').textContent=v.code;
      row.querySelector('.vcopy').addEventListener('click',function(){
        var btn=this;
        var copied=(navigator.clipboard&&navigator.clipboard.writeText)?navigator.clipboard.writeText(v.code):Promise.reject();
        copied.then(function(){btn.textContent='Copied';setTimeout(function(){btn.textContent='Copy'},1600);},function(){
          try{var r=document.createRange();r.selectNodeContents(row.querySelector('.vcode'));var s=getSelection();s.removeAllRanges();s.addRange(r);btn.textContent='Select & copy';}catch(e){}
        });
      });
      host.appendChild(row);
    });
  }
  var vnotice=ROOT.querySelector('[data-notice="voucher"]');
  if(vnotice){
    if(list.length){
      var cash=list.filter(function(v){return v.kind==='cash'&&v.amount});
      var title=vnotice.querySelector('[data-n="vtitle"]');
      if(title)title.textContent=cash.length?('You have a $'+Number(cash[0].amount).toLocaleString()+' voucher ready to use'):(list.length>1?('You have '+list.length+' reward vouchers ready to use'):'You have a reward voucher ready to use');
      vnotice.hidden=false;
    } else {vnotice.hidden=true;}
  }
}
document.addEventListener('rfm-vouchers-updated',function(){renderVouchers()});
document.addEventListener('rfm-loyalty-refresh',function(){refreshLoyaltyAfterRedeem()});
renderVouchers();
/* ---- dashboard notices: proven Rivo facts only ---- */
function formatRivoDate(value){
  /* RFM_DATE_ONLY_SAFE_V1 */
  if(!value) return '';
  var raw=String(value).trim();
  var iso=raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/);
  if(iso){
    return new Date(Date.UTC(Number(iso[1]),Number(iso[2])-1,Number(iso[3])))
      .toLocaleDateString('en-US',{year:'numeric',month:'short',day:'numeric',timeZone:'UTC'});
  }
  var parsed=new Date(raw); if(!Number.isFinite(parsed.getTime())) return raw;
  return parsed.toLocaleDateString('en-US',{year:'numeric',month:'short',day:'numeric'});
}
function renderNotices(){
  var D=RFM_LOYALTY,host=ROOT.querySelector('#dashNotices'); if(!D||!host) return;
  host.querySelectorAll('[data-notice]').forEach(function(e){e.hidden=true});
  function show(k){var e=host.querySelector('[data-notice="'+k+'"]');if(e)e.hidden=false;return e;}
  if(IS_D8&&D.infinityX!==null){
    ROOT.classList.add('rfm-d8'); show('d8');
    ROOT.querySelectorAll('[data-n="d8x"],[data-n="bandx"]').forEach(function(e){e.textContent=D.infinityX+'×'});
    var ms=ROOT.querySelector('[data-n="mSub"]');if(ms)ms.textContent='Infinity Day is on.';
    var bandEl=ROOT.querySelector('.d8ribbon');
    if(bandEl){bandEl.hidden=false;var tv=bandEl.querySelector('[data-n="bandcount"]');if(tv){(function tick(){
      var et=new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'}));
      var end=new Date(et);end.setHours(23,59,59,999);
      var seconds=Math.max(0,Math.floor((end-et)/1000));
      var hh=Math.floor(seconds/3600),mm=Math.floor(seconds%3600/60),ss=seconds%60;
      tv.textContent=(hh<10?'0':'')+hh+':'+(mm<10?'0':'')+mm+':'+(ss<10?'0':'')+ss;
      setTimeout(tick,1000);
    })();}}
  }
  /* Member Month banner (Aug 2026): pre = teaser, on = tier-personalized auto-discount line. Discounts: Rookie 12 / Grinder 14 / Beast+Legend 16 (2026-07-29 plan). */
  var mmEl=ROOT.querySelector('.mmribbon');
  if(mmEl){
    if(MM_STATE){
      var MM_PCT={Rookie:12,Grinder:14,Beast:16,Legend:16};
      var mmPct=D.tier&&MM_PCT[D.tier]?MM_PCT[D.tier]:null;
      var mmIsM=ROOT.classList.contains('rfmm');
      var mmCopy=mmEl.querySelector('[data-mm="copy"]');
      if(mmCopy){
        if(MM_STATE==='pre'){mmCopy.innerHTML=mmIsM?'Starts <b>Aug 8</b>':'Starts <b>Aug 8</b> &mdash; automatic tier discounts all month';}
        else if(mmPct){mmCopy.innerHTML=mmIsM?('<b>'+D.tier+'</b>: <b>'+mmPct+'% off</b> auto'):('Your <b>'+D.tier+'</b> tier gets <b>'+mmPct+'% off</b> automatically');}
        else{mmCopy.innerHTML=mmIsM?'Up to <b>16% off</b> auto':'Member discounts up to <b>16% off</b> are automatic';}
      }
      mmEl.hidden=false;
    } else {mmEl.hidden=true;}
  }
  if(IS_FLASH) show('flash');
  if(IS_MMGIFT) show('mmgift');
  /* Upcoming board rows (Aug 2026, year-locked): MM row until Aug 31, Flash row until the last draw day. */
  var upMM=MM_STATE!==null||(ET_TODAY>='2026-07-01'&&ET_TODAY<='2026-08-31');
  var upFlash=IS_FLASH||(ET_TODAY>='2026-07-01'&&ET_TODAY<='2026-08-28');
  ROOT.querySelectorAll('[data-up="mm"]').forEach(function(e){e.hidden=!upMM});
  ROOT.querySelectorAll('[data-up="flash"]').forEach(function(e){e.hidden=!upFlash});
  if(RFM_RIVO.birthdayReminder(D)||IS_BDAY_PREVIEW) show('bday');
  if(D.expiring&&D.expiring.date){
    var expiry=show('expiry');var date=expiry&&expiry.querySelector('[data-n="exdate"]');
    if(date)date.textContent=formatRivoDate(D.expiring.date);
  }
  renderVouchers();
}

function rfmNumber(value){return value===null?'—':Number(value).toLocaleString();}
function rfmMoney(points){if(points===null)return '—';var value=points*0.05;return '$'+(Number.isInteger(value)?value.toFixed(0):value.toFixed(2));}
function rfmSetText(selector,value){ROOT.querySelectorAll(selector).forEach(function(e){e.textContent=value});}
function renderProgress(D){
  /* RFM_TIER_PROGRESS_V2 — earned-based progress from the Rivo vip payload; balance must never drive tier progress (redemptions would fake a downgrade). */
  var thresholds={Rookie:0,Grinder:1500,Beast:2500,Legend:4500};
  var highest=D.tier==='Legend';
  var valid=D.tier&&(highest||(D.nextTier&&D.nextTierAt!==null&&D.toEarn!==null&&D.progressPct!==null));
  var label,note,number,percentage=0;
  if(highest){label='Legend — highest tier';number=rfmNumber(D.balance)+' pts';note='Legend is the highest tier — and tiers never downgrade.';percentage=100;}
  else if(valid){
    var earned=Math.max(0,D.nextTierAt-D.toEarn);
    percentage=Math.max(0,Math.min(100,D.progressPct));
    label='Progress to '+D.nextTier;
    number=rfmNumber(earned)+' / '+rfmNumber(D.nextTierAt)+' pts earned';
    note='Just '+rfmNumber(D.toEarn)+' points to unlock '+D.nextTier+' — about $'+rfmNumber(Math.ceil(D.toEarn/Math.max(0.01,D.tierX)))+' more in spend.';
  } else {label='Tier progress unavailable';number='—';note='We could not load enough information to calculate tier progress.';}
  rfmSetText('.snap-row .t',label);rfmSetText('.snap-row .n',number);rfmSetText('.snap-note',note);
  rfmSetText('.tprog .row1 .t',highest?label:(D.tier?"You're a "+D.tier+(D.nextTier?' · next up '+D.nextTier:''):label));
  rfmSetText('.tprog .row1 .n',number);rfmSetText('.tprog .note',note);
  ROOT.querySelectorAll('.prog-fill').forEach(function(e){e.style.width=percentage.toFixed(1)+'%'});
}
function renderTierMarker(D){
  var tiers=['Rookie','Grinder','Beast','Legend'];CURRENT_TIER_INDEX=tiers.indexOf(D.tier);
  var table=ROOT.querySelector('.ttable');
  if(table){
    table.querySelectorAll('tr').forEach(function(row){Array.prototype.slice.call(row.children,1).forEach(function(cell,index){cell.classList.toggle('col-you',index===CURRENT_TIER_INDEX)})});
    var old=table.querySelector('.you');if(old)old.remove();
    if(CURRENT_TIER_INDEX>=0){var th=table.querySelectorAll('thead th')[CURRENT_TIER_INDEX+1];if(th){var you=document.createElement('span');you.className='you';you.textContent='YOU';th.appendChild(you);}}
  }
  if(typeof renderTier==='function'&&CURRENT_TIER_INDEX>=0)renderTier(CURRENT_TIER_INDEX);
}
var RFM_ACTIVITY_ICON_RULES=[
  [/order|purchase/i,'shopping-bag'],
  [/redeem|reward|voucher|coupon/i,'gift'],
  [/review/i,'star'],
  [/birthday/i,'cake'],
  [/refer|friend/i,'users'],
  [/fitness/i,'user-heart'],
  [/sign\s*up/i,'user-check'],
  [/follow|social|tiktok|instagram/i,'camera']
];
function rfmActivityIcon(note,positive){
  for(var i=0;i<RFM_ACTIVITY_ICON_RULES.length;i++){if(RFM_ACTIVITY_ICON_RULES[i][0].test(note||''))return RFM_ACTIVITY_ICON_RULES[i][1];}
  return positive?'coin':'gift';
}
function rfmActivityIconHTML(name){
  var tpl=ROOT.querySelector('template[data-icon="'+name+'"]');
  return tpl?tpl.innerHTML:'';
}
function rfmActivityDate(iso){
  var d=new Date(iso);
  if(isNaN(d.getTime()))return '';
  return d.toLocaleDateString('en-US',{month:'short',day:'2-digit',year:'numeric',timeZone:'America/New_York'});
}
function renderHonestActivity(){
  if(RFM_MODE!=='real')return;
  var FALLBACK='<h3>Recent activity</h3><div class="sub">A supported loyalty activity feed is not available here yet.</div><div class="orders-empty">Your real purchase history remains available under Orders.</div>';
  ROOT.querySelectorAll('[data-rivo-activity]').forEach(function(host){
    var channel=window.RivoJS;
    if(!channel||typeof channel.getCustomerPointsLogs!=='function'){host.innerHTML=FALLBACK;return;}
    channel.getCustomerPointsLogs().then(function(resp){
      var logs=(resp&&resp.points_logs)||[];
      if(!logs.length){host.innerHTML='<h3>Recent activity</h3><div class="sub">No activity yet — earn or redeem points to see it here.</div>';return;}
      var expanded=false;
      function paint(){
        var shown=expanded?logs:logs.slice(0,5);
        var rows=shown.map(function(log){
          var diff=log.points_diff||0,positive=diff>=0;
          var note=log.external_note||log.title||(positive?'Points earned':'Points redeemed');
          var icon=rfmActivityIcon(note,positive);
          var amt=(positive?'+':'')+rfmNumber(diff);
          return '<div class="act"><div class="icsq">'+rfmActivityIconHTML(icon)+'</div><div><div class="t">'+note+'</div><div class="d">'+rfmActivityDate(log.applied_at)+'</div></div><div class="amt'+(positive?'':' neg')+'">'+amt+'</div></div>';
        }).join('');
        var toggle=logs.length>5?'<a class="na" href="#" data-activity-toggle>'+(expanded?'Show less':'View all')+'</a>':'';
        host.innerHTML='<div style="display:flex;justify-content:space-between;align-items:baseline"><h3>Recent activity</h3>'+toggle+'</div><div class="sub">Your latest points.</div><div style="margin-top:10px">'+rows+'</div>';
        var link=host.querySelector('[data-activity-toggle]');
        if(link)link.addEventListener('click',function(e){e.preventDefault();expanded=!expanded;paint();});
      }
      paint();
    }).catch(function(){
      host.innerHTML=FALLBACK;
    });
  });
}
function configureCash(D){
  BAL=D.balance;
  if(BAL!==null&&BAL>=300){var maximum=Math.min(3000,Math.max(300,Math.floor(BAL/10)*10));slider.max=maximum;slider.value=Math.min(maximum,600);}
  var available=ROOT.querySelector('.cash-meta span:last-child b');if(available)available.textContent=rfmNumber(BAL);
  updCash();renderGear();
}
function renderSummary(D){
  var tier=D.tier||'Tier unavailable',points=rfmNumber(D.balance),worth=rfmMoney(D.balance);
  rfmSetText('.snap-tier',D.tier?tier+' Tier':tier);rfmSetText('.snap-pts',points+(D.balance===null?'':' pts'));
  rfmSetText('.snap-worth b',worth);rfmSetText('.pts-chip .tier',D.tier||'—');rfmSetText('.pts-chip b',points);
  rfmSetText('.topbar .chip>div:nth-child(1) .cv',D.tier||'—');rfmSetText('.topbar .chip>div:nth-child(2) .cv',points);
  ROOT.querySelectorAll('.topbar .chip>div:nth-child(3) .cv').forEach(function(e){e.textContent=worth+' in rewards'});
  rfmSetText('[data-rivo-balance-copy]',D.balance===null?'Your current points balance is unavailable.':'Turn '+points+' pts into cash off or free gear.');
  rfmSetText('.rec-note b',D.tier&&D.tierX!==null?D.tier+' '+D.tierX+'×':'your verified tier');
  rfmSetText('.infinity-card:not([data-up]) .t',D.infinityX!==null?D.infinityX+'× Points On The 8th':'Infinity Day multiplier unavailable');
  rfmSetText('[data-rivo-birthday]',D.birthMonth?new Date(2020,D.birthMonth-1,1).toLocaleDateString('en-US',{month:'long'})+' birth month on file':'Not set');
  renderProgress(D);renderTierMarker(D);
}
function configureReferral(D){
  /* RFM_REF_SHARE_V2 — referrers copy their link in place; navigating to your own
     referral URL shows the friend-facing claim popup, which is the wrong audience. */
  RFM_REFERRAL_URL=D&&D.referralUrl?D.referralUrl:null;
  ROOT.querySelectorAll('[data-rivo-referral]').forEach(function(link){
    link.removeAttribute('href');link.removeAttribute('target');link.removeAttribute('rel');
    if(RFM_REFERRAL_URL){
      link.classList.remove('is-disabled');link.removeAttribute('aria-disabled');
      link.innerHTML='Get Your Link <i class="ti ti-arrow-right"></i>';
    } else {
      link.classList.add('is-disabled');link.setAttribute('aria-disabled','true');
      link.textContent='Referral link unavailable';
    }
  });
  var panel=ROOT.querySelector('[data-ref-share]');
  var urlEl=ROOT.querySelector('[data-ref-url]');
  if(panel){panel.hidden=true;}
  if(urlEl&&RFM_REFERRAL_URL){urlEl.textContent=RFM_REFERRAL_URL;}
}
function renderRecommendations(){
  if(RFM_MODE==='demo'){renderRec(REC_DEFAULT);return;}
  if(!RFM)return;
  if(!RFM.orders||!RFM.orders.length){renderRec(REC_FIRST_ORDER);return;}
  if(location.protocol==='file:'){renderRec(REC_DEFAULT);return;}
  var lines=[];RFM.orders.forEach(function(o){(o.items||[]).forEach(function(i){lines.push(i)})});
  if(!lines.length){renderRec(REC_DEFAULT);return;}
  var owned={};lines.forEach(function(i){owned[i.pid]=1});
  var seed=lines.sort(function(a,b){return (b.price||0)-(a.price||0)})[0];
  var cap=Math.max(150,seed.price/100*0.15);
  function accept(p){var v=(p.variants&&p.variants[0])||{},price=(+v.price||0)/100;return !owned[p.id]&&p.product_type!==seed.type&&p.available!==false&&price>0&&price<=cap;}
  function toCard(p){var v=p.variants[0],price=+v.price/100,im=(p.featured_image&&(p.featured_image.src||p.featured_image)||'').replace(/^\/\//,'https://');return {name:p.title.replace(/^RitFit\s+/,''),price:price,from:p.variants.length>1,img:im+(im.indexOf('?')>-1?'&':'?')+'width=280',url:'https://www.ritfitsports.com/products/'+p.handle+'?ref=member-dashboard-rec'};}
  function apply(products){var picks=(products||[]).filter(accept).slice(0,4).map(toCard);if(!picks.length){renderRec(REC_DEFAULT);return;}var names={};picks.forEach(function(p){names[p.name]=1});REC_DEFAULT.forEach(function(p){if(picks.length<4&&!names[p.name])picks.push(p)});renderRec(picks);}
  fetch('/recommendations/products.json?product_id='+seed.pid+'&limit=10&intent=complementary').then(function(r){return r.json()}).then(function(data){if(data.products&&data.products.length){apply(data.products);return;}return fetch('/recommendations/products.json?product_id='+seed.pid+'&limit=10&intent=related').then(function(r){return r.json()}).then(function(next){apply(next.products)});}).catch(function(){renderRec(REC_DEFAULT)});
}
function renderLoyalty(D){
  RFM_LOYALTY=D;TIER_X=D.tierX;renderSummary(D);configureCash(D);configureReferral(D);renderNotices();renderHonestActivity();renderRecommendations();loadShopRewards();refreshCashCta();refreshBdayEdit();
}
function setLoyaltyState(state){
  if(!RFM_SHELL)return;
  RFM_SHELL.classList.remove('rfm-loyalty-loading','rfm-loyalty-error');RFM_SHELL.setAttribute('data-rivo-state',state);
  var status=RFM_SHELL.querySelector('[data-rivo-status]'),title=status&&status.querySelector('[data-rivo-status-title]'),copy=status&&status.querySelector('[data-rivo-status-copy]'),retry=status&&status.querySelector('[data-rivo-retry]');
  if(!status)return;
  status.hidden=state!=='loading'&&state!=='error';retry.hidden=state!=='error';RFM_SHELL.setAttribute('aria-busy',state==='loading'?'true':'false');
  if(state==='loading'){RFM_SHELL.classList.add('rfm-loyalty-loading');title.textContent='Loading your rewards…';copy.textContent='Please wait while we load your current RitFit Rewards details.';}
  if(state==='error'){RFM_SHELL.classList.add('rfm-loyalty-error');title.textContent="We couldn't load your rewards.";copy.textContent='Your account is still safe. Please retry to load your current points and tier.';}
}
function startLoyalty(){
  var token=++RFM_BOOT_TOKEN;
  RFM_RIVO.bootstrap({customer:RFM,location:location,window:window,document:document,timeoutMs:10000,demo:RFM_DEMO,onState:setLoyaltyState})
    .then(function(data){if(token!==RFM_BOOT_TOKEN||!data)return;renderLoyalty(data);setLoyaltyState('ready');})
    .catch(function(){/* setLoyaltyState('error') is emitted by the adapter; never use demo fallback. */});
}
var retryButton=RFM_SHELL&&RFM_SHELL.querySelector('[data-rivo-retry]');if(retryButton)retryButton.addEventListener('click',startLoyalty);
if(!IS_GATED)startLoyalty();

/* deep link: #earn / #redeem / ... */
function viewFromHash(){var h=location.hash.replace('#','');return h&&ROOT.querySelector('#'+'view-'+h)?h:'';}
var h0=viewFromHash();
if(h0){go(h0,false);}
window.addEventListener('popstate',function(){go(viewFromHash()||'dashboard',false)});

/* ---- profile interactions ---- */
var fpBody=ROOT.querySelector('#fpBody'),fpToggle=ROOT.querySelector('#fpToggle');
fpToggle.addEventListener('click',function(){
  var open=fpBody.classList.toggle('open');
  fpToggle.textContent=open?'Close':'Complete It';
});
ROOT.querySelectorAll('.chips .chipbtn').forEach(function(c){
  c.addEventListener('click',function(){
    var wrap=c.parentElement;
    if(wrap.hasAttribute('data-single')){wrap.querySelectorAll('.chipbtn').forEach(function(x){x.classList.remove('on')});c.classList.add('on');}
    else c.classList.toggle('on');
  });
});
/* ---- RFM_REAL_ACTIONS_V1: fitness profile save (Klaviyo) + birthday (RivoJS) ---- */
var FP_STORE_KEY='rfm-fitness-profile-v1';
function fpKlaviyo(){
  var k=window.klaviyo;
  if(k&&typeof k.identify==='function')return {identify:function(p){return Promise.resolve(k.identify(p));}};
  var lq=window._learnq;
  if(lq&&typeof lq.push==='function')return {identify:function(p){lq.push(['identify',p]);return Promise.resolve(true);}};
  return null;
}
function fpCollect(){
  var out={goals:[],experience:'',space:'',shopping:[]};
  if(!fpBody)return out;
  fpBody.querySelectorAll('.fgroup').forEach(function(group){
    var labelEl=group.querySelector('.gl');
    var label=labelEl?labelEl.textContent:'';
    var picked=[].map.call(group.querySelectorAll('.chipbtn.on'),function(chip){return chip.textContent.trim();});
    if(/goals/i.test(label))out.goals=picked;
    else if(/experience/i.test(label))out.experience=picked[0]||'';
    else if(/space/i.test(label))out.space=picked[0]||'';
    else if(/shopping/i.test(label))out.shopping=picked;
  });
  return out;
}
function fpApplySaved(){
  if(RFM_MODE!=='real'||!fpBody)return;
  var saved=null;
  try{saved=JSON.parse(localStorage.getItem(FP_STORE_KEY)||'null');}catch(error){}
  var chips=fpBody.querySelectorAll('.chipbtn');
  chips.forEach(function(chip){chip.classList.remove('on');});
  if(saved&&saved.values){
    var picked={};
    saved.values.forEach(function(value){picked[value]=1;});
    chips.forEach(function(chip){if(picked[chip.textContent.trim()])chip.classList.add('on');});
  }
  if(!saved&&!window.RFM_FITNESS_DONE)return;
  if(fpSave)fpSave.disabled=true;
  fpShowNote('Fitness profile completed. Your +100 points reward is secured.',false);
}
var fpSave=ROOT.querySelector('[data-fp-save]');
var fpNote=ROOT.querySelector('[data-fp-note]');
function fpShowNote(text,isError){
  if(!fpNote)return;
  fpNote.hidden=false;fpNote.textContent=text;fpNote.classList.toggle('err',!!isError);
}
if(fpSave)fpSave.addEventListener('click',function(){
  if(RFM_MODE!=='real'){fpShowNote('Demo preview — profile saving is disabled.',true);return;}
  if(!RFM||!RFM.email){fpShowNote('We could not confirm your account email. Please refresh and try again.',true);return;}
  var channel=fpKlaviyo();
  if(!channel){fpShowNote('Profile saving is temporarily unavailable. Please try again later.',true);return;}
  var data=fpCollect();
  if(!data.goals.length&&!data.experience&&!data.space&&!data.shopping.length){fpShowNote('Pick at least one option first.',true);return;}
  fpSave.disabled=true;
  var savedAt=new Date().toISOString();
  channel.identify({
    '$email':RFM.email,
    'rfm_fitness_goals':data.goals.join(', '),
    'rfm_experience_level':data.experience,
    'rfm_training_space':data.space,
    'rfm_shopping_for':data.shopping.join(', '),
    'rfm_fitness_profile_saved_at':savedAt
  }).then(function(){
    try{
      localStorage.setItem(FP_STORE_KEY,JSON.stringify({
        values:[].concat(data.goals,[data.experience],[data.space],data.shopping).filter(Boolean),
        saved_at:savedAt
      }));
    }catch(error){}
    fpSave.disabled=true;
    fpShowNote('Saved! Your +100 points reward will be added shortly.',false);refreshFitnessMove();
  }).catch(function(){
    fpSave.disabled=false;
    fpShowNote('We could not save your profile. Please try again.',true);
  });
});
fpApplySaved();
function refreshFitnessMove(){
  var card=ROOT.querySelector('[data-move="fitness"]'); if(!card)return;
  var saved=null;
  try{saved=JSON.parse(localStorage.getItem(FP_STORE_KEY)||'null');}catch(error){}
  var localDone=!!(saved&&saved.values&&saved.values.length);
  card.hidden=RFM_MODE==='real'&&(localDone||!!window.RFM_FITNESS_DONE);
}
refreshFitnessMove();
var bdaySave=ROOT.querySelector('[data-bday-save]');
var bdayNote=ROOT.querySelector('[data-bday-note]');
function bdayShowNote(text,isError){
  if(!bdayNote)return;
  bdayNote.hidden=false;bdayNote.textContent=text;bdayNote.classList.toggle('err',!!isError);
}
function refreshBdayEdit(){
  var row=ROOT.querySelector('[data-bday-edit]'); if(!row)return;
  var api=window.RivoJS;
  var usable=RFM_MODE==='real'&&api&&typeof api.updateCustomerDob==='function';
  row.hidden=!(usable&&RFM_LOYALTY&&RFM_LOYALTY.birthMonth===null);
}
if(bdaySave)bdaySave.addEventListener('click',function(){
  if(RFM_MODE!=='real'){bdayShowNote('Demo preview — saving is disabled.',true);return;}
  var input=ROOT.querySelector('[data-bday-input]');
  var value=input&&input.value;
  if(!value){bdayShowNote('Pick your birth date first.',true);return;}
  var parsed=new Date(value+'T00:00:00Z');
  var age=(Date.now()-parsed.getTime())/31557600000;
  if(!Number.isFinite(parsed.getTime())||age<13||age>120){bdayShowNote('Please enter a valid birth date.',true);return;}
  var api=window.RivoJS;
  if(!api||typeof api.updateCustomerDob!=='function'){bdayShowNote('Birthday updates are temporarily unavailable.',true);return;}
  bdaySave.disabled=true;
  Promise.resolve(api.updateCustomerDob(value)).then(function(ok){
    if(ok===false)throw new Error('rejected');
    /* mirror to Klaviyo so the birthday flow can trigger (Rivo's own property sync does not fire for storefront DOB writes; 1940 = legacy year placeholder) */
    try{var bdCh=fpKlaviyo();if(bdCh&&RFM&&RFM.email){var bdMirror='1940-'+value.slice(5);bdCh.identify({'$email':RFM.email,'Rivo Date of Birth':bdMirror,'rfm_dob':bdMirror});}}catch(mirrorErr){}
    bdayShowNote('Birthday saved! Your birthday rewards will use this date.',false);
    var row=ROOT.querySelector('[data-bday-edit]');
    if(row)row.hidden=true;
    refreshLoyaltyAfterRedeem();
  }).catch(function(){
    bdaySave.disabled=false;
    bdayShowNote('We could not save your birthday. It may already be set on your account.',true);
  });
});
refreshBdayEdit();

/* ---- addresses view (embedded 2026-07-23) ---- */
var ADDR=window.RFM_ADDRESSES||null;
var ADDR_DEMO=[
  {id:1,firstName:'Alex',lastName:'Rivera',company:'',address1:'2500 Summer St',address2:'Apt 12',city:'Houston',province:'Texas',provinceCode:'TX',country:'United States',countryCode:'US',zip:'77007',phone:'(713) 555-0142'},
  {id:2,firstName:'Alex',lastName:'Rivera',company:'RitFit Home Gym',address1:'88 Congress Ave',address2:'',city:'Austin',province:'Texas',provinceCode:'TX',country:'United States',countryCode:'US',zip:'78701',phone:''}
];
function addrEsc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]});}
(function(){
  var host=ROOT.querySelector('#addrList'); if(!host) return;
  var isDemo=!ADDR&&RFM_MODE==='demo';
  var items=ADDR?(ADDR.items||[]):(isDemo?ADDR_DEMO:[]);
  var defaultId=ADDR?ADDR.defaultId:(isDemo?1:null);
  items=items.slice().sort(function(a,b){return (String(b.id)===String(defaultId)?1:0)-(String(a.id)===String(defaultId)?1:0);});
  var wrap=ROOT.querySelector('#addrFormWrap');
  var formTitle=ROOT.querySelector('#addrFormTitle');
  var form=ROOT.querySelector('#addrForm');
  var addBtn=ROOT.querySelector('#addrAddBtn');
  var listNoteEl=ROOT.querySelector('#addrListNote');
  var countrySel=form?form.querySelector('[data-addr-country]'):null;
  var provinceSel=form?form.querySelector('[data-addr-province]'):null;
  var provinceWrap=form?form.querySelector('[data-addr-province-wrap]'):null;
  var methodInp=form?form.querySelector('[data-addr-method]'):null;
  var noteEl=form?form.querySelector('[data-addr-note]'):null;
  var busy=false;

  function listNote(msg,err){if(!listNoteEl)return;listNoteEl.hidden=false;listNoteEl.textContent=msg;listNoteEl.style.color=err?'#b3261e':'';}
  function note(msg,err){if(!noteEl)return;noteEl.hidden=false;noteEl.textContent=msg;noteEl.style.color=err?'#b3261e':'';}
  function provinceData(){
    if(!countrySel||countrySel.selectedIndex<0)return[];
    var opt=countrySel.options[countrySel.selectedIndex]; if(!opt)return[];
    var raw=opt.getAttribute('data-provinces'); if(!raw)return[];
    try{return JSON.parse(raw)||[]}catch(e){return[]}
  }
  function syncProvinces(want){
    if(!provinceSel)return;
    var provs=provinceData();
    provinceSel.innerHTML='';
    if(!provs.length){if(provinceWrap)provinceWrap.hidden=true;provinceSel.disabled=true;return;}
    if(provinceWrap)provinceWrap.hidden=false;provinceSel.disabled=false;
    provs.forEach(function(p){var o=document.createElement('option');o.value=p[0];o.textContent=p[1];provinceSel.appendChild(o);});
    if(want){
      provinceSel.value=want;
      if(provinceSel.value!==want){for(var i=0;i<provinceSel.options.length;i++){if(provinceSel.options[i].textContent===want){provinceSel.selectedIndex=i;break;}}}
    }
  }
  function setF(n,v){var el=form.elements['address['+n+']'];if(el)el.value=v==null?'':v;}
  function openForm(mode,a){
    if(!form||!wrap)return;
    form.reset();
    if(noteEl){noteEl.hidden=true;noteEl.textContent='';}
    setF('first_name',a&&a.firstName);setF('last_name',a&&a.lastName);setF('company',a&&a.company);
    setF('address1',a&&a.address1);setF('address2',a&&a.address2);setF('city',a&&a.city);
    setF('zip',a&&a.zip);setF('phone',a&&a.phone);
    if(countrySel){
      countrySel.value=(a&&a.country)||'United States';
      if(countrySel.selectedIndex<0&&countrySel.options.length)countrySel.selectedIndex=0;
    }
    syncProvinces(a?(a.provinceCode||a.province||''):'');
    var dflt=form.querySelector('[data-addr-default]');
    if(dflt)dflt.checked=a?String(a.id)===String(defaultId):false;
    if(mode==='edit'&&a){form.action='/account/addresses/'+a.id;if(methodInp)methodInp.disabled=false;}
    else{form.action='/account/addresses';if(methodInp)methodInp.disabled=true;}
    if(formTitle)formTitle.textContent=mode==='edit'?'Edit address':'Add a new address';
    wrap.hidden=false;
    var sb=form.querySelector('[data-addr-submit]'); if(sb)sb.disabled=false;
    if(wrap.scrollIntoView)wrap.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  function closeForm(){if(wrap)wrap.hidden=true;}
  function fmtLines(a){
    var l1=[a.address1,a.address2].filter(Boolean).join(', ');
    var l2=[a.city,(a.provinceCode||a.province),a.zip].filter(Boolean).join(', ');
    return [l1,l2,a.country].filter(Boolean);
  }
  function render(){
    if(!items.length){host.innerHTML='<div class="addr-empty">No addresses saved yet — add your first shipping address below.</div>';return;}
    host.innerHTML=items.map(function(a){
      var isD=String(a.id)===String(defaultId);
      var name=addrEsc([a.firstName,a.lastName].filter(Boolean).join(' '))||'—';
      var lines=fmtLines(a).map(function(x){return '<div class="addr-line">'+addrEsc(x)+'</div>'}).join('');
      var comp=a.company?'<div class="addr-line addr-co">'+addrEsc(a.company)+'</div>':'';
      var phone=a.phone?'<div class="addr-line addr-phone">'+addrEsc(a.phone)+'</div>':'';
      return '<div class="addr-card">'
        +(isD?'<span class="addr-badge">Default</span>':'')
        +'<div class="addr-name">'+name+'</div>'+comp+lines+phone
        +'<div class="addr-ops">'
        +'<button class="addr-op" type="button" data-addr-edit="'+addrEsc(a.id)+'">Edit</button>'
        +'<button class="addr-op addr-del" type="button" data-addr-rm="'+addrEsc(a.id)+'">Delete</button>'
        +(isD?'':'<button class="addr-op" type="button" data-addr-mkdef="'+addrEsc(a.id)+'">Set as default</button>')
        +'</div></div>';
    }).join('');
  }
  function byId(id){return items.filter(function(x){return String(x.id)===String(id)})[0]||null;}
  function postAddr(url,fd,btn){
    if(busy)return;busy=true;if(btn)btn.disabled=true;
    fetch(url,{method:'POST',body:fd,credentials:'same-origin',redirect:'follow'}).then(function(r){
      if(r.ok&&r.redirected){location.reload();return;}
      busy=false;if(btn)btn.disabled=false;
      var msg=r.ok?'Couldn\'t save — please check the required fields and try again.':'Something went wrong ('+r.status+'). Please try again.';
      note(msg,true);listNote(msg,true);
    }).catch(function(){
      busy=false;if(btn)btn.disabled=false;
      note('Network error — please try again.',true);listNote('Network error — please try again.',true);
    });
  }
  function delAddr(id){
    if(isDemo){listNote('Demo preview — address changes are disabled here.');return;}
    if(!window.confirm('Delete this address?'))return;
    var fd=new FormData();fd.append('_method','delete');
    postAddr('/account/addresses/'+id,fd,null);
  }
  function mkDefault(id){
    if(isDemo){listNote('Demo preview — address changes are disabled here.');return;}
    var a=byId(id); if(!a)return;
    var fd=new FormData();
    fd.append('form_type','customer_address');fd.append('utf8','✓');fd.append('_method','put');
    [['first_name',a.firstName],['last_name',a.lastName],['company',a.company],['address1',a.address1],['address2',a.address2],['city',a.city],['province',a.provinceCode||a.province],['country',a.country],['zip',a.zip],['phone',a.phone]].forEach(function(p){fd.append('address['+p[0]+']',p[1]==null?'':p[1]);});
    fd.append('address[default]','1');
    postAddr('/account/addresses/'+id,fd,null);
  }
  if(addBtn)addBtn.addEventListener('click',function(){openForm('new',null);});
  host.addEventListener('click',function(e){
    var t=e.target&&e.target.closest?e.target.closest('button.addr-op'):null; if(!t)return;
    if(t.hasAttribute('data-addr-edit')){var a=byId(t.getAttribute('data-addr-edit'));if(a)openForm('edit',a);}
    else if(t.hasAttribute('data-addr-rm')){delAddr(t.getAttribute('data-addr-rm'));}
    else if(t.hasAttribute('data-addr-mkdef')){mkDefault(t.getAttribute('data-addr-mkdef'));}
  });
  if(countrySel)countrySel.addEventListener('change',function(){syncProvinces('');});
  if(form)form.addEventListener('submit',function(e){
    e.preventDefault();
    if(isDemo){note('Demo preview — saving is disabled here.',true);return;}
    var sb=form.querySelector('[data-addr-submit]');
    postAddr(form.getAttribute('action'),new FormData(form),sb);
  });
  var cancelBtn=form?form.querySelector('[data-addr-cancel]'):null;
  if(cancelBtn)cancelBtn.addEventListener('click',closeForm);
  render();
})();

/* smart store link: Android UA → Google Play, everyone else → App Store */
(function(){
  var link=ROOT.querySelector('[data-app-link]'); if(!link) return;
  if(/android/i.test(navigator.userAgent))link.href='https://play.google.com/store/apps/details?id=com.ritfitsports.ritfit';
})();

/* survey gate: hide every survey entry for customers already tagged 'Survey'
   (tag maintained by the survey owner; Liquid-computed, see RFM_SURVEY_DONE) */
(function(){
  if(window.RFM_SURVEY_DONE!==true) return;
  ROOT.querySelectorAll('[data-survey-entry]').forEach(function(el){el.hidden=true;el.style.display='none';});
})();

})();

/* ===== mobile (m- ids) ===== */
(function(){
var ROOT=document.getElementsByClassName('rfmm')[0]; if(!ROOT) return;
ROOT.classList.add('rfm-ready');

/* ---- view switching (tabs + drawer) ---- */
function go(view,writeHistory){
  ROOT.querySelectorAll('.tab').forEach(function(t){t.classList.toggle('active',t.dataset.view===view)});
  ROOT.querySelectorAll('.d-item[data-view]').forEach(function(d){d.classList.toggle('active',d.dataset.view===view)});
  ROOT.querySelectorAll('.view').forEach(function(v){v.classList.toggle('active',v.id==='m-view-'+view)});
  var tab=ROOT.querySelector('.tab[data-view="'+view+'"]');
  if(tab) tab.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
  relocateRec(view);
  window.scrollTo({top:0});
  closeDrawer();
  if(writeHistory!==false&&location.hash!=='#'+view){history.pushState(null,'','#'+view);}
}
ROOT.querySelectorAll('.tab,.d-item[data-view]').forEach(function(el){el.addEventListener('click',function(){go(el.dataset.view)})});
ROOT.querySelectorAll('[data-goto]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();go(a.dataset.goto)})});

/* ---- exposure batch 2026-08-06: rec block follows earn/redeem/tiers, ref rewritten per view ---- */
var REC_VIEWS={earn:1,redeem:1,tiers:1};
function relocateRec(view){
  var blk=ROOT.querySelector('#m-recBlock');if(!blk)return;
  if(view===undefined){var av=ROOT.querySelector('.view.active');view=av?av.id.replace('m-view-',''):'earn';}
  var target=REC_VIEWS[view]?view:'earn';
  var host=ROOT.querySelector('#m-view-'+target);
  if(host&&blk.parentNode!==host){host.appendChild(blk);}
  blk.querySelectorAll('a[href*="ref=member-dashboard-rec"]').forEach(function(a){
    a.href=a.href.replace(/ref=member-dashboard-rec[a-z-]*/,'ref=member-dashboard-rec-'+target);
  });
}
var _renderRecBase=renderRec;
renderRec=function(list){_renderRecBase(list);relocateRec();};
/* ---- home referral banner: reuses RFM_REFERRAL_URL, hooks independent of the earn card ---- */
(function(){
  var t=ROOT.querySelector('[data-refbanner-toggle]');if(!t)return;
  var panel=ROOT.querySelector('[data-refbanner-share]');
  var urlEl=ROOT.querySelector('[data-refbanner-url]');
  var copy=ROOT.querySelector('[data-refbanner-copy]');
  t.addEventListener('click',function(){
    if(!RFM_REFERRAL_URL)return;
    if(urlEl)urlEl.textContent=RFM_REFERRAL_URL;
    if(panel)panel.hidden=!panel.hidden;
  });
  if(copy)copy.addEventListener('click',function(){
    if(!RFM_REFERRAL_URL)return;
    try{navigator.clipboard.writeText(RFM_REFERRAL_URL).catch(function(){});}catch(e){}
    copy.textContent='Copied!';setTimeout(function(){copy.textContent='Copy invite link';},1600);
  });
})();

/* ---- drawer ---- */
var drawer=ROOT.querySelector('#m-drawer'),scrim=ROOT.querySelector('#m-scrim');
function closeDrawer(){drawer.classList.remove('on');scrim.classList.remove('on')}
ROOT.querySelector('#m-burger').addEventListener('click',function(){drawer.classList.add('on');scrim.classList.add('on')});
ROOT.querySelector('#m-drawerClose').addEventListener('click',closeDrawer);
scrim.addEventListener('click',closeDrawer);

/* ---- tiers data (base v0.4, 10 rows) ---- */
var PERKS=[
  {k:'Points Earn Rate',v:['1×','1×','1.25×','1.5×'],t:'txt'},
  {k:'Infinity Day Bonus (8th of Each Month)',v:['2×','2×','2.5×','3×'],t:'txt'},
  {k:'Redeem Points for Cash & Free Gear',v:[1,1,1,1],t:'ck'},
  {k:'24-Month Point Validity',v:[1,1,1,1],t:'ck'},
  {k:'Refer-a-Friend Rewards',v:[1,1,1,1],t:'ck'},
  {k:'Members-Only Events & Deals',v:[1,1,1,1],t:'ck'},
  {k:'Birthday Bonus',v:['★','★★','★★★','★★★★'],t:'star'},
  {k:'Early Access to Product Drops',v:[0,0,1,1],t:'ck'},
  {k:'Priority Support',v:[0,0,1,1],t:'ck'},
  {k:'1-on-1 Gear Consult',v:[0,0,0,1],t:'ck'}
];
var TIERS=[{n:'Rookie',th:'0 pts'},{n:'Grinder',th:'1,500 pts'},{n:'Beast',th:'2,500 pts'},{n:'Legend',th:'4,500 pts'}];
function renderTier(i){
  var t=TIERS[i];
  var html='<div class="tp-h"><span class="n">'+t.n+(i===CURRENT_TIER_INDEX?' <span style="font-size:10px;background:var(--red);color:#fff;padding:3px 9px;border-radius:999px;vertical-align:3px">YOU</span>':'')+'</span><span class="th">'+t.th+'</span></div>';
  PERKS.forEach(function(p){
    var val=p.v[i], cell;
    if(p.t==='txt') cell='<span class="v">'+val+'</span>';
    else if(p.t==='star') cell='<span class="v star">'+val+'</span>';
    else cell=val?'<span class="v ck">✓</span>':'<span class="v dash">—</span>';
    html+='<div class="trow"><span class="k">'+p.k+'</span>'+cell+'</div>';
  });
  ROOT.querySelector('#m-tpanel').innerHTML=html;
  ROOT.querySelectorAll('.ttab').forEach(function(b){b.classList.toggle('active',+b.dataset.tier===i)});
}
ROOT.querySelectorAll('.ttab').forEach(function(b){b.addEventListener('click',function(){renderTier(+b.dataset.tier)})});
renderTier(0);

/* ---- redeem cash slider (v0.4 bands) ---- */
/* RFM_RIVO_ADAPTER_V1 — proven store paths only; no Merchant API. */
var RFM_RIVO=(function(){
  var TIER_MAP={
    Rookie:{tierX:1,infinityX:2},
    Grinder:{tierX:1,infinityX:2},
    Beast:{tierX:1.25,infinityX:2.5},
    Legend:{tierX:1.5,infinityX:3}
  };
  function flag(search,name){return new RegExp('(?:^|[?&])'+name+'=1(?:&|$)').test(search||'');}
  function mode(customer,loc){
    loc=loc||{};
    if(flag(loc.search,'gate')) return 'guest';
    if(loc.protocol==='file:'||flag(loc.search,'demo')) return 'demo';
    return customer?'real':'guest';
  }
  function finite(value){
    var number=typeof value==='number'?value:Number(value);
    return Number.isFinite(number)?number:null;
  }
  function tierName(value,optional){
    if(value===null||value===undefined||String(value).trim()==='') return null;
    var raw=String(value).trim().toLowerCase();
    var names=Object.keys(TIER_MAP);
    for(var i=0;i<names.length;i++) if(names[i].toLowerCase()===raw) return names[i];
    if(optional) return null;
    var error=new Error('Unsupported Rivo tier name'); error.name='RivoSchemaError'; throw error;
  }
  function birthMonth(value){
    if(typeof value!=='string'||!value.trim()) return null;
    var raw=value.trim();
    var match=raw.match(/^\d{4}-(\d{2})-(\d{2})/);
    if(match){var month=Number(match[1]);return month>=1&&month<=12?month:null;}
    /* Rivo's legacy widget stores birthdays as MM-DD or M-D (no year); Safari parses "07-09" as year 7 / month 9 via new Date, so match it explicitly */
    var legacy=raw.match(/^(\d{1,2})-(\d{1,2})$/);
    if(legacy){var legacyMonth=Number(legacy[1]);return legacyMonth>=1&&legacyMonth<=12?legacyMonth:null;}
    var parsed=new Date(raw);
    return Number.isFinite(parsed.getTime())?parsed.getUTCMonth()+1:null;
  }
  function birthDay(value){
    if(typeof value!=='string'||!value.trim()) return null;
    var raw=value.trim(),month=birthMonth(raw),day;
    var iso=raw.match(/^\d{4}-\d{2}-(\d{2})(?:$|[T\s])/);
    var legacy=raw.match(/^\d{1,2}-(\d{1,2})$/);
    if(iso||legacy) day=Number((iso||legacy)[1]);
    else {var parsed=new Date(raw);day=Number.isFinite(parsed.getTime())?parsed.getUTCDate():null;}
    var maxDay=month?[31,29,31,30,31,30,31,31,30,31,30,31][month-1]:0;
    return Number.isInteger(day)&&day>=1&&day<=maxDay?day:null;
  }
  function birthdayReminder(details,now){
    var month=details&&details.birthMonth,day=details&&details.birthDay;
    if(!Number.isInteger(month)||month<1||month>12||!Number.isInteger(day)||day<1||day>[31,29,31,30,31,30,31,31,30,31,30,31][month-1]) return false;
    now=now||new Date();
    if(!Number.isFinite(now.getTime())) return false;
    /* Compare local calendar dates as UTC day numbers so DST cannot shorten the window. */
    var year=now.getFullYear(),today=Date.UTC(year,now.getMonth(),now.getDate());
    for(var y=year-1;y<=year+1;y++){
      /* Feb 29 uses February's last day in non-leap years for this reminder only. */
      var anniversary=Date.UTC(y,month-1,Math.min(day,new Date(Date.UTC(y,month,0)).getUTCDate()));
      if(Math.abs(anniversary-today)<=7*86400000) return true;
    }
    return false;
  }
  function httpUrl(value){
    if(typeof value!=='string'||!value.trim()) return null;
    try {
      var parsed=new URL(value,'https://www.ritfitsports.com');
      return parsed.protocol==='https:'||parsed.protocol==='http:'?parsed.href:null;
    } catch (error) { return null; }
  }
  function normalize(details,vip,referrals){
    details=details&&typeof details==='object'?details:{};
    vip=vip&&typeof vip==='object'?vip:{};
    referrals=referrals&&typeof referrals==='object'?referrals:{};
    var rawTier=vip.tier&&vip.tier.name;
    var tier=tierName(rawTier,false);
    var map=tier?TIER_MAP[tier]:null;
    var highest=vip.highest_tier===true||tier==='Legend';
    var next=highest?null:tierName(vip.next_tier&&vip.next_tier.name,true);
    var balance=finite(details.points_tally);
    if(balance!==null) balance=Math.max(0,Math.floor(balance));
    var nextAt=highest?null:finite(vip.next_tier&&vip.next_tier.threshold);
    if(nextAt!==null) nextAt=Math.max(0,Math.floor(nextAt));
    var expiry=typeof details.points_expiry==='string'&&details.points_expiry.trim()?details.points_expiry.trim():null;
    var toEarn=highest?null:finite(vip.next_tier&&vip.next_tier.to_spend_or_earn);
    if(toEarn!==null) toEarn=Math.max(0,Math.ceil(toEarn));
    var progressPct=highest?null:finite(vip.percentage_to_next_tier);
    return {
      balance:balance,
      tier:tier,
      tierX:map?map.tierX:null,
      nextTier:next,
      nextTierAt:nextAt,
      toEarn:toEarn,
      progressPct:progressPct,
      infinityX:map?map.infinityX:null,
      birthMonth:birthMonth(details.dob),
      birthDay:birthDay(details.dob),
      expiring:{pts:null,date:expiry},
      referralUrl:httpUrl(referrals.url)||httpUrl(details.referral_url)
    };
  }
  function hasApi(api){
    return !!api&&['getCustomerDetails','getCustomerVipTier','getCustomerReferrals'].every(function(name){return typeof api[name]==='function';});
  }
  function waitForApi(win,doc,timeoutMs){
    if(hasApi(win&&win.RivoJS)) return Promise.resolve(win.RivoJS);
    return new Promise(function(resolve,reject){
      var done=false;
      function cleanup(){
        if(doc&&typeof doc.removeEventListener==='function') doc.removeEventListener('rivo-js-loaded',ready);
        clearTimeout(timer);
      }
      function ready(){
        if(done||!hasApi(win&&win.RivoJS)) return;
        done=true; cleanup(); resolve(win.RivoJS);
      }
      if(doc&&typeof doc.addEventListener==='function') doc.addEventListener('rivo-js-loaded',ready);
      var timer=setTimeout(function(){
        if(done) return; done=true; cleanup();
        var error=new Error('RivoJS did not become ready'); error.name='RivoTimeoutError'; reject(error);
      },Math.max(1,timeoutMs||10000));
    });
  }
  function fetchAll(api){
    return Promise.all([
      api.getCustomerDetails(),
      api.getCustomerVipTier(),
      api.getCustomerReferrals()
    ]);
  }
  async function bootstrap(options){
    options=options||{};
    var currentMode=mode(options.customer,options.location||{});
    var onState=typeof options.onState==='function'?options.onState:function(){};
    if(currentMode==='guest') return null;
    if(currentMode==='demo') return options.demo||null;
    onState('loading');
    try {
      var api=await waitForApi(options.window||{},options.document||{},options.timeoutMs||10000);
      var payloads=await fetchAll(api);
      return normalize(payloads[0],payloads[1],payloads[2]);
    } catch (error) {
      onState('error',error);
      throw error;
    }
  }
  return {mode:mode,normalize:normalize,birthdayReminder:birthdayReminder,waitForApi:waitForApi,fetchAll:fetchAll,bootstrap:bootstrap,tierMap:TIER_MAP};
})();
/* ---- member + loyalty data boundary (Task 4) ---- */
var RFM=window.RFM_CUSTOMER||null;
var RFM_MODE=RFM_RIVO.mode(RFM,location);
var IS_GATED=RFM_MODE==='guest';
var RFM_DEMO={name:'Alex',balance:1240,tier:'Rookie',tierX:1,nextTier:'Grinder',nextTierAt:1500,toEarn:260,progressPct:82.7,infinityX:2,birthMonth:7,expiring:{pts:200,date:'Sep 12, 2026'},referralUrl:'https://example.com/demo-referral',vouchers:[{code:'BAL-DEMO4F2A9C01',name:'$170 off coupon',kind:'cash',amount:170,min_cart:null,applied_at:'2026-07-18T12:00:00Z',expires_at:null},{code:'BAL-DEMO7B3E5D02',name:'Free Crystal Plate',kind:'gear',amount:null,min_cart:null,applied_at:'2026-07-05T12:00:00Z',expires_at:'2026-08-30T00:00:00Z'}]};
var RFM_LOYALTY=null;
var RFM_SHELL=ROOT.querySelector('[data-rivo-shell]');
var CURRENT_TIER_INDEX=-1;
var RFM_BOOT_TOKEN=0;
/* Infinity Day = the 8th (ET). ?d8=1 forces preview of the Infinity state. */
var IS_D8=/[?&]d8=1/.test(location.search)||new Date().toLocaleDateString('en-US',{timeZone:'America/New_York',day:'numeric'})==='8';
/* Member Month Aug 2026 (ET). ?mm=pre / ?mm=on force preview; year-locked so it cannot resurface in 2027. */
var ET_TODAY=new Date().toLocaleDateString('en-CA',{timeZone:'America/New_York'});
var MM_STATE=/[?&]mm=pre\b/.test(location.search)?'pre':/[?&]mm=on\b/.test(location.search)?'on':(ET_TODAY>='2026-08-05'&&ET_TODAY<='2026-08-07')?'pre':(ET_TODAY>='2026-08-08'&&ET_TODAY<='2026-08-31')?'on':null;
/* Flash Day draw dates (ET), per the approved MM V2 plan. ?flash=1 forces preview. */
var IS_FLASH=/[?&]flash=1/.test(location.search)||ET_TODAY==='2026-08-08'||ET_TODAY==='2026-08-18'||ET_TODAY==='2026-08-28';
/* MM member-exclusive gift notice window (Aug 2026, year-locked). ?mmgift=1 forces preview. */
var IS_MMGIFT=/[?&]mmgift=1/.test(location.search)||(ET_TODAY>='2026-08-08'&&ET_TODAY<='2026-08-31');
/* ?bday=1 previews the birthday reminder; normal display is D-7 through D+7 in the customer's local calendar. */
var IS_BDAY_PREVIEW=/[?&]bday=1/.test(location.search);
if(IS_GATED){ROOT.classList.add('rfm-gated');ROOT.querySelector('.gate-card').hidden=false;}
if(RFM){var nm=RFM.firstName||'Member';
  ROOT.querySelectorAll('[data-rfm="firstName"]').forEach(function(e){e.textContent=nm});
  ROOT.querySelectorAll('[data-rfm="email"]').forEach(function(e){e.textContent=RFM.email||''});
}

/* ---- orders list (v9) ---- */
var ORDERS_DEMO=[{name:'#RF-20418',date:'Jun 24, 2026',total:'$248.00',status:'Fulfilled',url:'#'},
                 {name:'#RF-19876',date:'May 12, 2026',total:'$89.99',status:'Fulfilled',url:'#'}];
(function(){
  var host=ROOT.querySelector('#m-ordersList'); if(!host) return;
  var list=RFM?(RFM.orders||[]):(RFM_MODE==='demo'?ORDERS_DEMO:[]);
  if(!list.length){host.innerHTML='<div class="orders-empty">No orders yet — your history will appear here.<br><a class="btn btn-red" href="https://www.ritfitsports.com/?ref=member-dashboard-orders">Shop Now</a></div>';return;}
  host.innerHTML=list.map(function(o){return '<div class="orow"><span class="oid">'+o.name+'</span><span class="od">'+o.date+'</span><span class="ot">'+o.total+'</span><span class="os">'+(o.status||'')+'</span>'+(o.url&&o.url!=='#'?'<a class="ov" href="'+o.url+'">View</a>':'')+'</div>'}).join('');
})();
var BAL=null;
var slider=ROOT.querySelector('#m-cashSlider');
function band(p){ if(p<=500) return '$99.99'; if(p<=1500) return '$299.99'; return '$799.99'; }
function updCash(){
  var cashPts=ROOT.querySelector('#m-cashPts'),cashVal=ROOT.querySelector('#m-cashVal'),cashTier=ROOT.querySelector('#m-cashTier');
  if(BAL===null||BAL<300){
    slider.disabled=true; slider.min=300; slider.max=300; slider.value=300;
    cashPts.textContent='Not available'; cashVal.textContent='—';
    cashTier.textContent=BAL===null?'Points balance is unavailable.':'Earn at least 300 points to redeem.';
    slider.style.setProperty('--pct','0%'); return;
  }
  slider.disabled=false;
  var p=+slider.value;
  cashPts.textContent=p.toLocaleString()+' pts';
  cashVal.textContent='$'+(p*0.05).toFixed(2)+' Off';
  cashTier.innerHTML='Applies to orders over <b>'+band(p)+'</b> · voucher valid 90 days';
  slider.style.setProperty('--pct',((p-300)/Math.max(1,(+slider.max||300)-300)*100)+'%');
}
slider.addEventListener('input',function(){updCash();refreshCashCta();}); updCash();

/* ---- gear grid ---- */
var REDEEM=[{"name": "Water Bottle", "points": 624, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-57f355ca-jpg')}, {"name": "RitFit Sports Cap", "points": 624, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-362883d3-jpg')}, {"name": "Sports Towel", "points": 374, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-ffe39cc6-jpg')}, {"name": "Non-Slip Yoga Mat", "points": 749, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-4207876c-jpg')}, {"name": "Crystal Plate", "points": 624, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-e0896741-jpg')}, {"name": "Preacher Curl Pad", "points": 749, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-f8fae7c4-jpg')}, {"name": "Dumbbells 55LB Pair", "points": 3249, "img": ROOT.getAttribute('data-rfm-asset-rfm-dash-img-e1852c1f-jpg')}];
var grid=ROOT.querySelector('#m-gearGrid');
var GEAR_LIVE=[];
function gearImageFor(name){
  var key=String(name||'').toLowerCase().replace(/^free\s+/,'').trim();
  for(var i=0;i<REDEEM.length;i++){
    var demoKey=REDEEM[i].name.toLowerCase();
    if(key.indexOf(demoKey)!==-1||demoKey.indexOf(key)!==-1)return REDEEM[i].img;
  }
  return null;
}
function renderGear(){
  grid.innerHTML='';
  if(BAL===null){grid.innerHTML='<div class="orders-empty">Points balance is unavailable.</div>';return;}
  var isDemo=RFM_MODE==='demo';
  if(!isDemo){
    if(!RFM_REWARDS.loaded){grid.innerHTML='<div class="orders-empty">Loading rewards…</div>';return;}
    if(RFM_REWARDS.error||!rmApi()){grid.innerHTML='<div class="orders-empty">We could not load the rewards catalog right now. Please refresh to try again.</div>';return;}
    if(!RFM_REWARDS.gear.length){grid.innerHTML='<div class="orders-empty">No free gear rewards are available right now.</div>';return;}
  }
  GEAR_LIVE=isDemo
    ?REDEEM.map(function(p){return {id:null,name:p.name,points:p.points,img:p.img};})
    :RFM_REWARDS.gear.map(function(r){return {id:r.id,name:r.name.replace(/^Free\s+/i,''),points:r.points,img:r.image||gearImageFor(r.name)};});
  GEAR_LIVE.forEach(function(p,idx){
    var can=p.points<=BAL;
    var el=document.createElement('div');
    el.className='card gcard';
    el.innerHTML=(p.img?'<img src="'+p.img+'" alt="">':'<div class="gcard-noimg" aria-hidden="true">RitFit</div>')+
      '<div class="n"></div><div class="p">'+p.points.toLocaleString()+' pts</div>'+
      (can?'<button type="button" data-rm-gear-idx="'+idx+'">Redeem</button>':'<button type="button" disabled>Need '+(p.points-BAL).toLocaleString()+' more</button>');
    el.querySelector('.n').textContent=p.name;
    grid.appendChild(el);
  });
}
grid.addEventListener('click',function(event){
  var btn=event.target&&event.target.closest?event.target.closest('[data-rm-gear-idx]'):null;
  if(!btn||btn.disabled)return;
  var item=GEAR_LIVE[+btn.getAttribute('data-rm-gear-idx')];
  if(item)openRedeemModal({kind:'gear',reward:item});
});

/* ---- recommended for you (v9: data-driven renderer + tier-crossing nudge + Infinity Day rate) ----
   Production wiring (Codex batch): Liquid customer.orders seed -> /recommendations/products.json
   (intent=complementary, fallback related; that endpoint returns prices in CENTS) -> filter
   owned / same product_type as seed / unavailable / price-cap -> call renderRec(cards).
   renderRec owns sorting + Infinity math; the data source never needs to know.
   REC_DEFAULT = curated live-catalog facts (2026-07-16); also the no-history / fetch-failure fallback. */
var TIER_X=null;
var REC_DEFAULT=[
 {name:'GATOR 1600LB Adjustable Bench', price:359.99, from:false,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/img_v3_02rq_7d851ab7-cead-49e4-ac81-1ecc07218f3g.jpg?v=1762506572&width=280',
  url:'https://www.ritfitsports.com/products/ritfit-gator-adjustable-weight-bench?ref=member-dashboard-rec'},
 {name:'Fleck Olympic Bumper Plates', price:99.99, from:true,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/15_88e462e0-3c01-4a66-84ab-31d93cfd3640.jpg?v=1712481220&width=280',
  url:'https://www.ritfitsports.com/products/ritfit-fleck-bumper-plates-2-inch-olympic-rubber-weight-plates?ref=member-dashboard-rec'},
 {name:'AT04 Leg Press Foot Plate', price:99.99, from:false,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/173972f8ba4bc6cdcfde6ccfdf127a97.jpg?v=1755138917&width=280',
  url:'https://www.ritfitsports.com/products/ritfit-foot-plate-for-leg-press-at04?ref=member-dashboard-rec'},
 {name:'Decagon PEV Dumbbells', price:25.99, from:true,
  img:'https://cdn.shopify.com/s/files/1/2350/9323/files/2_3.webp?v=1774332801&width=280',
  url:'https://www.ritfitsports.com/products/toughfit-decagon-shape-dumbbells-pev?ref=member-dashboard-rec'}
];
/* 登录但无订单 → 首单旗舰位（用户 7/17 拍板：明星/旗舰主机，价格梯入门→旗舰；不走配件价格帽）。live catalog 2026-07-17。 */
var REC_FIRST_ORDER=[
 {name:"M1 PRO Multi-Functional Smith Machine", price:1299.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/1_dd5cda42-f5b4-47e2-b007-cc5c1f219fc7.jpg?v=1759039529&width=280",
  url:'https://www.ritfitsports.com/products/m1-multi-functional-home-gym-smith-machine?ref=member-dashboard-rec'},
 {name:"M3 Smith Machine with Cable Crossover", price:2999.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/ritfit-m3-power-rack-smith-cable-crossover-black-silver-grey-bg.webp?v=1778134874&width=280",
  url:'https://www.ritfitsports.com/products/m3-power-rack-cable-crossover-smith-machine?ref=member-dashboard-rec'},
 {name:"M1 Smith Machine with Cable Crossover", price:1069.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/6_2.webp?v=1774332360&width=280",
  url:'https://www.ritfitsports.com/products/ritfit-m1-smith-machine-with-cable-crossover-system-for-home-gym?ref=member-dashboard-rec'},
 {name:"P3 Power Cage with Smooth Cable System", price:719.99, from:true,
  img:"https://cdn.shopify.com/s/files/1/2350/9323/files/P3_Black_gray_background.jpg?v=1773994914&width=280",
  url:'https://www.ritfitsports.com/products/ritfit-p3-1200lbs-power-cage-with-smooth-cable-system?ref=member-dashboard-rec'}
];
var rg=ROOT.querySelector('#m-recGrid');
function renderRec(list){
  var D=RFM_LOYALTY;
  if(!D||D.balance===null||D.tierX===null){rg.innerHTML='<div class="orders-empty">Recommendations require current loyalty data.</div>';return;}
  var gap=D.nextTier?Math.max(0,D.nextTierAt-D.balance):0;
  var needSpend=(D.nextTier&&gap>0)?gap/D.tierX:Infinity;
  var mult=IS_D8?D.infinityX:1;
  rg.innerHTML='';
  list.slice().sort(function(a,b){return (b.price>=needSpend)-(a.price>=needSpend)})
  .forEach(function(p){
    var pts=Math.floor(p.price*D.tierX*mult);
    var el=document.createElement('div');
    el.className='card rcard';
    el.innerHTML='<img class="rimg" src="'+p.img+'" alt="'+p.name+'" loading="lazy">'+
      '<div class="n">'+p.name+'</div>'+
      '<div class="prow"><div class="price">'+(p.from?'<small>From </small>':'')+'$'+p.price.toFixed(2)+'</div><span class="ppts">Earn +'+pts.toLocaleString()+' pts'+(mult>1?' ('+D.infinityX+'\u00d7)':'')+'</span></div>'+
      '<a class="rbtn" href="'+p.url+'" target="_blank" rel="noopener">View Product</a>';
    rg.appendChild(el);
  });
}
/* rendered after loyalty bootstrap */

/* ---- RFM_REAL_ACTIONS_V1: live rewards catalog + real RivoJS redemption ---- */
var RFM_REWARDS={loaded:false,cash:[],gear:[],error:null};
var RM_BUSY=false;
var RM_CTX=null;
var CASH_BANDS=[
  {name:'Iron',min:300,max:500,order:'$99.99'},
  {name:'Steel',min:501,max:1500,order:'$299.99'},
  {name:'Titanium',min:1501,max:3000,order:'$799.99'}
];
function rmApi(){var a=window.RivoJS;return a&&typeof a.redeemReward==='function'?a:null;}
function rmListApi(){var a=window.RivoJS;return a&&typeof a.getShopRewards==='function'?a:null;}
function rmNum(v){var n=typeof v==='number'?v:Number(v);return Number.isFinite(n)?n:null;}
function rmStr(v){return typeof v==='string'&&v.trim()?v.trim():null;}
function normalizeReward(r){
  if(!r||typeof r!=='object')return null;
  var id=r.id===undefined||r.id===null?null:String(r.id);
  var name=rmStr(r.name)||rmStr(r.title);
  if(r.enabled===false||!id||!name)return null;
  var type=(rmStr(r.reward_type)||rmStr(r.type)||'').toLowerCase();
  return {id:id,name:name,type:type,points:rmNum(r.points_amount),image:rmStr(r.icon_url)||rmStr(r.image_url)};
}
function classifyRewards(list){
  var cash=[],gear=[];
  (Array.isArray(list)?list:[]).forEach(function(item){
    var reward=normalizeReward(item); if(!reward)return;
    if(/^(iron|steel|titanium) reward/i.test(reward.name)){cash.push(reward);return;}
    if(reward.type==='free_product'&&reward.points!==null&&reward.points>0)gear.push(reward);
  });
  gear.sort(function(a,b){return a.points-b.points});
  return {cash:cash,gear:gear};
}
function loadShopRewards(){
  if(RFM_MODE!=='real')return;
  var api=rmListApi();
  if(!api){RFM_REWARDS.loaded=true;RFM_REWARDS.error='unsupported';refreshCashCta();renderGear();return;}
  api.getShopRewards().then(function(list){
    var grouped=classifyRewards(list&&list.rewards?list.rewards:list);
    RFM_REWARDS={loaded:true,error:null,cash:grouped.cash,gear:grouped.gear};
    refreshCashCta();renderGear();
  }).catch(function(){
    RFM_REWARDS.loaded=true;RFM_REWARDS.error='load';
    refreshCashCta();renderGear();
  });
}
function cashBandFor(points){
  for(var i=0;i<CASH_BANDS.length;i++){if(points>=CASH_BANDS[i].min&&points<=CASH_BANDS[i].max)return CASH_BANDS[i];}
  return null;
}
function cashRewardFor(band){
  if(!band)return null;
  for(var i=0;i<RFM_REWARDS.cash.length;i++){
    if(RFM_REWARDS.cash[i].name.toLowerCase().indexOf(band.name.toLowerCase())===0)return RFM_REWARDS.cash[i];
  }
  return null;
}
function refreshCashCta(){
  var btn=ROOT.querySelector('[data-rm-cash-btn]'); if(!btn)return;
  var note=ROOT.querySelector('[data-rm-cash-note]');
  function say(text){if(note){note.hidden=!text;if(text)note.textContent=text;}}
  if(RFM_MODE==='demo'){btn.disabled=false;say('');return;}
  if(RFM_MODE!=='real'||BAL===null||BAL<300){btn.disabled=true;say('');return;}
  if(!RFM_REWARDS.loaded){btn.disabled=true;say('');return;}
  var band=cashBandFor(+slider.value||0);
  var ok=!!rmApi()&&!RFM_REWARDS.error&&!!cashRewardFor(band);
  btn.disabled=!ok;
  if(ok){say('');}
  else if(RFM_REWARDS.error==='unsupported'){say('Cash redemption is temporarily unavailable here. Please try again later.');}
  else if(RFM_REWARDS.error){say('We could not load redemption options. Refresh to try again.');}
  else{say('Cash redemption is temporarily unavailable for this amount.');}
}
function rmStepShow(step){
  ROOT.querySelectorAll('[data-rm-step]').forEach(function(el){el.hidden=el.getAttribute('data-rm-step')!==step;});
}
function openRedeemModal(ctx){
  var overlay=ROOT.querySelector('[data-rm-overlay]'); if(!overlay)return;
  RM_CTX=ctx;RM_BUSY=false;
  var copyEl=ROOT.querySelector('[data-rm-copy]');
  var fineEl=ROOT.querySelector('[data-rm-fine]');
  var confirmBtn=ROOT.querySelector('[data-rm-confirm]');
  if(confirmBtn)confirmBtn.disabled=false;
  if(RFM_MODE==='demo'){
    if(copyEl)copyEl.textContent=ctx.kind==='cash'
      ?'Demo preview — redeeming '+ctx.points.toLocaleString()+' points for $'+(ctx.points*0.05).toFixed(2)+' off.'
      :'Demo preview — redeeming '+ctx.reward.points.toLocaleString()+' points for '+ctx.reward.name+'.';
    if(fineEl)fineEl.textContent='Redemption is disabled in demo mode.';
    if(confirmBtn)confirmBtn.disabled=true;
  } else if(ctx.kind==='cash'){
    var band=cashBandFor(ctx.points);
    if(copyEl)copyEl.textContent='Redeem '+ctx.points.toLocaleString()+' points for a $'+(ctx.points*0.05).toFixed(2)+' off voucher?';
    if(fineEl)fineEl.textContent='Works on orders over '+(band?band.order:'—')+' · voucher valid 90 days · can\'t combine with promo codes.';
  } else {
    if(copyEl)copyEl.textContent='Redeem '+ctx.reward.points.toLocaleString()+' points for '+ctx.reward.name+'?';
    if(fineEl)fineEl.textContent='You\'ll receive a reward code to claim this gear at checkout.';
  }
  rmStepShow('confirm');
  overlay.hidden=false;
}
function closeRedeemModal(){
  var overlay=ROOT.querySelector('[data-rm-overlay]');
  if(overlay)overlay.hidden=true;
  RM_CTX=null;RM_BUSY=false;
}
function extractRedeemCode(data){
  function walk(node,depth){
    if(!node||typeof node!=='object'||depth>4)return null;
    var keys=['code','discount_code','coupon_code','voucher_code','reward_code'];
    for(var i=0;i<keys.length;i++){
      var value=node[keys[i]];
      if(typeof value==='string'&&value.trim())return value.trim();
    }
    for(var key in node){
      if(Object.prototype.hasOwnProperty.call(node,key)){
        var found=walk(node[key],depth+1);
        if(found)return found;
      }
    }
    return null;
  }
  return walk(data,0);
}
function refreshLoyaltyAfterRedeem(){
  if(RFM_MODE!=='real')return;
  RFM_RIVO.bootstrap({customer:RFM,location:location,window:window,document:document,timeoutMs:10000,demo:RFM_DEMO,onState:function(){}})
    .then(function(data){if(data)renderLoyalty(data);})
    .catch(function(){});
}
function performRedeem(){
  if(RM_BUSY||!RM_CTX||RFM_MODE!=='real')return;
  var api=rmApi();
  var errEl=ROOT.querySelector('[data-rm-error]');
  if(!api){if(errEl)errEl.textContent='Redemption is temporarily unavailable. Please try again later.';rmStepShow('error');return;}
  var rewardId=null,payload;
  if(RM_CTX.kind==='cash'){
    var band=cashBandFor(RM_CTX.points),reward=cashRewardFor(band);
    if(!reward){if(errEl)errEl.textContent='This amount is temporarily unavailable. Please adjust the slider and try again.';rmStepShow('error');return;}
    rewardId=reward.id;payload={points:RM_CTX.points};
  } else {
    rewardId=RM_CTX.reward.id;
  }
  RM_BUSY=true;rmStepShow('busy');
  Promise.resolve(payload===undefined?api.redeemReward(rewardId):api.redeemReward(rewardId,payload)).then(function(data){
    RM_BUSY=false;
    var code=extractRedeemCode(data);
    if(!code){
      if(errEl)errEl.textContent='We could not confirm this redemption. Please refresh the page, then check your points balance and Your vouchers before trying again.';
      rmStepShow('error');
      try{document.dispatchEvent(new CustomEvent('rfm-loyalty-refresh'))}catch(e){}
      return;
    }
    var codeWrap=ROOT.querySelector('[data-rm-code]');
    var codeValue=ROOT.querySelector('[data-rm-code-value]');
    var doneCopy=ROOT.querySelector('[data-rm-done-copy]');
    var doneFine=ROOT.querySelector('[data-rm-done-fine]');
    if(code&&codeWrap&&codeValue){codeValue.textContent=code;codeWrap.hidden=false;}
    else if(codeWrap){codeWrap.hidden=true;}
    if(doneCopy)doneCopy.textContent=RM_CTX&&RM_CTX.kind==='cash'
      ?'Your $'+(RM_CTX.points*0.05).toFixed(2)+' off voucher is ready.'
      :'Your reward is ready.';
    if(doneFine)doneFine.textContent='Apply this code at checkout. You can also find it anytime under Redeem \u2192 Your vouchers, and in your confirmation email.';
    rmStepShow('done');
    if(code&&window.RFM_VOUCHER_PUSH)window.RFM_VOUCHER_PUSH({code:code,name:(RM_CTX&&RM_CTX.kind==='cash')?('$'+(RM_CTX.points*0.05).toFixed(2).replace(/\.00$/,'')+' off coupon'):((RM_CTX&&RM_CTX.reward&&RM_CTX.reward.name)||'Reward voucher'),kind:(RM_CTX&&RM_CTX.kind==='cash')?'cash':'gear',amount:(RM_CTX&&RM_CTX.kind==='cash')?RM_CTX.points*0.05:null,min_cart:(function(){if(!RM_CTX||RM_CTX.kind!=='cash')return null;var b=cashBandFor(RM_CTX.points);return b?parseFloat(String(b.order).replace('$',''))||null:null;})(),applied_at:new Date().toISOString(),expires_at:(RM_CTX&&RM_CTX.kind==='cash')?new Date(Date.now()+90*86400000).toISOString():null});
    try{document.dispatchEvent(new CustomEvent('rfm-loyalty-refresh'))}catch(e){}
  }).catch(function(error){
    RM_BUSY=false;
    var message=error&&error.message?String(error.message):'';
    if(errEl)errEl.textContent=message&&message.length<160
      ?message
      :'Something went wrong and the redemption may not have completed. Please check your points balance before trying again.';
    rmStepShow('error');
  });
}
(function(){
  var overlay=ROOT.querySelector('[data-rm-overlay]'); if(!overlay)return;
  var cashBtn=ROOT.querySelector('[data-rm-cash-btn]');
  if(cashBtn)cashBtn.addEventListener('click',function(){
    if(RFM_MODE==='demo'){openRedeemModal({kind:'cash',points:+slider.value||600});return;}
    if(RFM_MODE!=='real'||BAL===null||BAL<300)return;
    var points=+slider.value;
    var band=cashBandFor(points);
    if(!band||!cashRewardFor(band))return;
    openRedeemModal({kind:'cash',points:points});
  });
  overlay.addEventListener('click',function(event){if(event.target===overlay&&!RM_BUSY)closeRedeemModal();});
  [['[data-rm-cancel]'],['[data-rm-close]'],['[data-rm-close-2]']].forEach(function(pair){
    var el=ROOT.querySelector(pair[0]);
    if(el)el.addEventListener('click',closeRedeemModal);
  });
  var confirmBtn=ROOT.querySelector('[data-rm-confirm]');
  if(confirmBtn)confirmBtn.addEventListener('click',performRedeem);
  var retryBtn=ROOT.querySelector('[data-rm-retry]');
  if(retryBtn)retryBtn.addEventListener('click',function(){rmStepShow('confirm');});
  var copyBtn=ROOT.querySelector('[data-rm-copy-btn]');
  if(copyBtn)copyBtn.addEventListener('click',function(){
    var value=ROOT.querySelector('[data-rm-code-value]');
    if(value&&navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(value.textContent).then(function(){
        copyBtn.textContent='Copied!';
        setTimeout(function(){copyBtn.textContent='Copy';},1500);
      }).catch(function(){});
    }
  });
})();

/* ---- RFM_REF_SHARE_V2: in-dashboard referral link reveal + copy ---- */
var RFM_REFERRAL_URL=null;
(function(){
  var trigger=ROOT.querySelector('[data-rivo-referral]');
  var panel=ROOT.querySelector('[data-ref-share]');
  var copyButton=ROOT.querySelector('[data-ref-copy]');
  if(trigger)trigger.addEventListener('click',function(event){
    event.preventDefault();
    if(!RFM_REFERRAL_URL||!panel)return;
    panel.hidden=false;
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(RFM_REFERRAL_URL).then(function(){
        if(copyButton){copyButton.textContent='Copied!';setTimeout(function(){copyButton.textContent='Copy';},1500);}
      }).catch(function(){});
    }
  });
  if(copyButton)copyButton.addEventListener('click',function(){
    if(!RFM_REFERRAL_URL)return;
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(RFM_REFERRAL_URL).then(function(){
        copyButton.textContent='Copied!';
        setTimeout(function(){copyButton.textContent='Copy';},1500);
      }).catch(function(){});
    }
  });
})();

/* ---- RFM_VOUCHERS_V1: redeemed voucher visibility (metafield-fed, sync-lagged) ---- */
var RFM_VOUCHER_STORE='rfm-vouchers-local:'+((RFM&&RFM.email)||'demo');
function rfmVoucherLocal(){try{return JSON.parse(localStorage.getItem(RFM_VOUCHER_STORE)||'[]')}catch(e){return []}}
function rfmVoucherList(){
  if(IS_GATED)return [];
  var base=RFM_MODE==='demo'?((RFM_DEMO&&RFM_DEMO.vouchers)||[]):((window.RFM_VOUCHERS&&window.RFM_VOUCHERS.vouchers)||[]);
  var merged=base.slice();
  rfmVoucherLocal().forEach(function(v){if(v&&v.code&&!merged.some(function(b){return b.code===v.code}))merged.push(v)});
  var now=new Date().toISOString();
  return merged.filter(function(v){return v&&v.code&&(!v.expires_at||v.expires_at>now)}).sort(function(a,b){return (a.applied_at||'')<(b.applied_at||'')?1:-1});
}
window.RFM_VOUCHER_PUSH=function(v){
  if(!v||!v.code)return;
  var list=rfmVoucherLocal();
  if(!list.some(function(b){return b&&b.code===v.code})){list.push(v);try{localStorage.setItem(RFM_VOUCHER_STORE,JSON.stringify(list.slice(-20)))}catch(e){}}
  try{document.dispatchEvent(new CustomEvent('rfm-vouchers-updated'))}catch(e){}
};
function renderVouchers(){
  var list=rfmVoucherList();
  var block=ROOT.querySelector('#m-voucherBlock'),host=ROOT.querySelector('#m-voucherList');
  if(block&&host){
    block.hidden=!list.length;
    host.innerHTML='';
    list.forEach(function(v){
      var row=document.createElement('div');row.className='vrow';
      row.innerHTML='<div class="vinfo"><div class="vname"></div><div class="vmeta"></div></div><code class="vcode"></code><button type="button" class="vcopy">Copy</button>';
      var meta=[];
      if(v.expires_at)meta.push('valid through '+formatRivoDate(v.expires_at));
      if(v.min_cart)meta.push('orders over $'+Number(v.min_cart).toFixed(2));
      meta.push('apply at checkout');
      row.querySelector('.vname').textContent=v.name||'Reward voucher';
      row.querySelector('.vmeta').textContent=meta.join(' · ');
      row.querySelector('.vcode').textContent=v.code;
      row.querySelector('.vcopy').addEventListener('click',function(){
        var btn=this;
        var copied=(navigator.clipboard&&navigator.clipboard.writeText)?navigator.clipboard.writeText(v.code):Promise.reject();
        copied.then(function(){btn.textContent='Copied';setTimeout(function(){btn.textContent='Copy'},1600);},function(){
          try{var r=document.createRange();r.selectNodeContents(row.querySelector('.vcode'));var s=getSelection();s.removeAllRanges();s.addRange(r);btn.textContent='Select & copy';}catch(e){}
        });
      });
      host.appendChild(row);
    });
  }
  var vnotice=ROOT.querySelector('[data-notice="voucher"]');
  if(vnotice){
    if(list.length){
      var cash=list.filter(function(v){return v.kind==='cash'&&v.amount});
      var title=vnotice.querySelector('[data-n="vtitle"]');
      if(title)title.textContent=cash.length?('You have a $'+Number(cash[0].amount).toLocaleString()+' voucher ready to use'):(list.length>1?('You have '+list.length+' reward vouchers ready to use'):'You have a reward voucher ready to use');
      vnotice.hidden=false;
    } else {vnotice.hidden=true;}
  }
}
document.addEventListener('rfm-vouchers-updated',function(){renderVouchers()});
document.addEventListener('rfm-loyalty-refresh',function(){refreshLoyaltyAfterRedeem()});
renderVouchers();
/* ---- dashboard notices: proven Rivo facts only ---- */
function formatRivoDate(value){
  /* RFM_DATE_ONLY_SAFE_V1 */
  if(!value) return '';
  var raw=String(value).trim();
  var iso=raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/);
  if(iso){
    return new Date(Date.UTC(Number(iso[1]),Number(iso[2])-1,Number(iso[3])))
      .toLocaleDateString('en-US',{year:'numeric',month:'short',day:'numeric',timeZone:'UTC'});
  }
  var parsed=new Date(raw); if(!Number.isFinite(parsed.getTime())) return raw;
  return parsed.toLocaleDateString('en-US',{year:'numeric',month:'short',day:'numeric'});
}
function renderNotices(){
  var D=RFM_LOYALTY,host=ROOT.querySelector('#m-dashNotices'); if(!D||!host) return;
  host.querySelectorAll('[data-notice]').forEach(function(e){e.hidden=true});
  function show(k){var e=host.querySelector('[data-notice="'+k+'"]');if(e)e.hidden=false;return e;}
  if(IS_D8&&D.infinityX!==null){
    ROOT.classList.add('rfm-d8'); show('d8');
    ROOT.querySelectorAll('[data-n="d8x"],[data-n="bandx"]').forEach(function(e){e.textContent=D.infinityX+'×'});
    var ms=ROOT.querySelector('[data-n="mSub"]');if(ms)ms.textContent='Infinity Day is on.';
    var bandEl=ROOT.querySelector('.d8ribbon');
    if(bandEl){bandEl.hidden=false;var tv=bandEl.querySelector('[data-n="bandcount"]');if(tv){(function tick(){
      var et=new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'}));
      var end=new Date(et);end.setHours(23,59,59,999);
      var seconds=Math.max(0,Math.floor((end-et)/1000));
      var hh=Math.floor(seconds/3600),mm=Math.floor(seconds%3600/60),ss=seconds%60;
      tv.textContent=(hh<10?'0':'')+hh+':'+(mm<10?'0':'')+mm+':'+(ss<10?'0':'')+ss;
      setTimeout(tick,1000);
    })();}}
  }
  /* Member Month banner (Aug 2026): pre = teaser, on = tier-personalized auto-discount line. Discounts: Rookie 12 / Grinder 14 / Beast+Legend 16 (2026-07-29 plan). */
  var mmEl=ROOT.querySelector('.mmribbon');
  if(mmEl){
    if(MM_STATE){
      var MM_PCT={Rookie:12,Grinder:14,Beast:16,Legend:16};
      var mmPct=D.tier&&MM_PCT[D.tier]?MM_PCT[D.tier]:null;
      var mmIsM=ROOT.classList.contains('rfmm');
      var mmCopy=mmEl.querySelector('[data-mm="copy"]');
      if(mmCopy){
        if(MM_STATE==='pre'){mmCopy.innerHTML=mmIsM?'Starts <b>Aug 8</b>':'Starts <b>Aug 8</b> &mdash; automatic tier discounts all month';}
        else if(mmPct){mmCopy.innerHTML=mmIsM?('<b>'+D.tier+'</b>: <b>'+mmPct+'% off</b> auto'):('Your <b>'+D.tier+'</b> tier gets <b>'+mmPct+'% off</b> automatically');}
        else{mmCopy.innerHTML=mmIsM?'Up to <b>16% off</b> auto':'Member discounts up to <b>16% off</b> are automatic';}
      }
      mmEl.hidden=false;
    } else {mmEl.hidden=true;}
  }
  if(IS_FLASH) show('flash');
  if(IS_MMGIFT) show('mmgift');
  /* Upcoming board rows (Aug 2026, year-locked): MM row until Aug 31, Flash row until the last draw day. */
  var upMM=MM_STATE!==null||(ET_TODAY>='2026-07-01'&&ET_TODAY<='2026-08-31');
  var upFlash=IS_FLASH||(ET_TODAY>='2026-07-01'&&ET_TODAY<='2026-08-28');
  ROOT.querySelectorAll('[data-up="mm"]').forEach(function(e){e.hidden=!upMM});
  ROOT.querySelectorAll('[data-up="flash"]').forEach(function(e){e.hidden=!upFlash});
  if(RFM_RIVO.birthdayReminder(D)||IS_BDAY_PREVIEW) show('bday');
  if(D.expiring&&D.expiring.date){
    var expiry=show('expiry');var date=expiry&&expiry.querySelector('[data-n="exdate"]');
    if(date)date.textContent=formatRivoDate(D.expiring.date);
  }
  renderVouchers();
}

function rfmNumber(value){return value===null?'—':Number(value).toLocaleString();}
function rfmMoney(points){if(points===null)return '—';var value=points*0.05;return '$'+(Number.isInteger(value)?value.toFixed(0):value.toFixed(2));}
function rfmSetText(selector,value){ROOT.querySelectorAll(selector).forEach(function(e){e.textContent=value});}
function renderProgress(D){
  /* RFM_TIER_PROGRESS_V2 — earned-based progress from the Rivo vip payload; balance must never drive tier progress (redemptions would fake a downgrade). */
  var thresholds={Rookie:0,Grinder:1500,Beast:2500,Legend:4500};
  var highest=D.tier==='Legend';
  var valid=D.tier&&(highest||(D.nextTier&&D.nextTierAt!==null&&D.toEarn!==null&&D.progressPct!==null));
  var label,note,number,percentage=0;
  if(highest){label='Legend — highest tier';number=rfmNumber(D.balance)+' pts';note='Legend is the highest tier — and tiers never downgrade.';percentage=100;}
  else if(valid){
    var earned=Math.max(0,D.nextTierAt-D.toEarn);
    percentage=Math.max(0,Math.min(100,D.progressPct));
    label='Progress to '+D.nextTier;
    number=rfmNumber(earned)+' / '+rfmNumber(D.nextTierAt)+' pts earned';
    note='Just '+rfmNumber(D.toEarn)+' points to unlock '+D.nextTier+' — about $'+rfmNumber(Math.ceil(D.toEarn/Math.max(0.01,D.tierX)))+' more in spend.';
  } else {label='Tier progress unavailable';number='—';note='We could not load enough information to calculate tier progress.';}
  rfmSetText('.snap-row .t',label);rfmSetText('.snap-row .n',number);rfmSetText('.snap-note',note);
  rfmSetText('.tprog .row1 .t',highest?label:(D.tier?"You're a "+D.tier+(D.nextTier?' · next up '+D.nextTier:''):label));
  rfmSetText('.tprog .row1 .n',number);rfmSetText('.tprog .note',note);
  ROOT.querySelectorAll('.prog-fill').forEach(function(e){e.style.width=percentage.toFixed(1)+'%'});
}
function renderTierMarker(D){
  var tiers=['Rookie','Grinder','Beast','Legend'];CURRENT_TIER_INDEX=tiers.indexOf(D.tier);
  var table=ROOT.querySelector('.ttable');
  if(table){
    table.querySelectorAll('tr').forEach(function(row){Array.prototype.slice.call(row.children,1).forEach(function(cell,index){cell.classList.toggle('col-you',index===CURRENT_TIER_INDEX)})});
    var old=table.querySelector('.you');if(old)old.remove();
    if(CURRENT_TIER_INDEX>=0){var th=table.querySelectorAll('thead th')[CURRENT_TIER_INDEX+1];if(th){var you=document.createElement('span');you.className='you';you.textContent='YOU';th.appendChild(you);}}
  }
  if(typeof renderTier==='function'&&CURRENT_TIER_INDEX>=0)renderTier(CURRENT_TIER_INDEX);
}
var RFM_ACTIVITY_ICON_RULES=[
  [/order|purchase/i,'shopping-bag'],
  [/redeem|reward|voucher|coupon/i,'gift'],
  [/review/i,'star'],
  [/birthday/i,'cake'],
  [/refer|friend/i,'users'],
  [/fitness/i,'user-heart'],
  [/sign\s*up/i,'user-check'],
  [/follow|social|tiktok|instagram/i,'camera']
];
function rfmActivityIcon(note,positive){
  for(var i=0;i<RFM_ACTIVITY_ICON_RULES.length;i++){if(RFM_ACTIVITY_ICON_RULES[i][0].test(note||''))return RFM_ACTIVITY_ICON_RULES[i][1];}
  return positive?'coin':'gift';
}
function rfmActivityIconHTML(name){
  var tpl=ROOT.querySelector('template[data-icon="'+name+'"]');
  return tpl?tpl.innerHTML:'';
}
function rfmActivityDate(iso){
  var d=new Date(iso);
  if(isNaN(d.getTime()))return '';
  return d.toLocaleDateString('en-US',{month:'short',day:'2-digit',year:'numeric',timeZone:'America/New_York'});
}
function renderHonestActivity(){
  if(RFM_MODE!=='real')return;
  var FALLBACK='<h3>Recent activity</h3><div class="sub">A supported loyalty activity feed is not available here yet.</div><div class="orders-empty">Your real purchase history remains available under Orders.</div>';
  ROOT.querySelectorAll('[data-rivo-activity]').forEach(function(host){
    var channel=window.RivoJS;
    if(!channel||typeof channel.getCustomerPointsLogs!=='function'){host.innerHTML=FALLBACK;return;}
    channel.getCustomerPointsLogs().then(function(resp){
      var logs=(resp&&resp.points_logs)||[];
      if(!logs.length){host.innerHTML='<h3>Recent activity</h3><div class="sub">No activity yet — earn or redeem points to see it here.</div>';return;}
      var expanded=false;
      function paint(){
        var shown=expanded?logs:logs.slice(0,5);
        var rows=shown.map(function(log){
          var diff=log.points_diff||0,positive=diff>=0;
          var note=log.external_note||log.title||(positive?'Points earned':'Points redeemed');
          var icon=rfmActivityIcon(note,positive);
          var amt=(positive?'+':'')+rfmNumber(diff);
          return '<div class="act"><div class="icsq">'+rfmActivityIconHTML(icon)+'</div><div><div class="t">'+note+'</div><div class="d">'+rfmActivityDate(log.applied_at)+'</div></div><div class="amt'+(positive?'':' neg')+'">'+amt+'</div></div>';
        }).join('');
        var toggle=logs.length>5?'<a class="na" href="#" data-activity-toggle>'+(expanded?'Show less':'View all')+'</a>':'';
        host.innerHTML='<div style="display:flex;justify-content:space-between;align-items:baseline"><h3>Recent activity</h3>'+toggle+'</div><div class="sub">Your latest points.</div><div style="margin-top:10px">'+rows+'</div>';
        var link=host.querySelector('[data-activity-toggle]');
        if(link)link.addEventListener('click',function(e){e.preventDefault();expanded=!expanded;paint();});
      }
      paint();
    }).catch(function(){
      host.innerHTML=FALLBACK;
    });
  });
}
function configureCash(D){
  BAL=D.balance;
  if(BAL!==null&&BAL>=300){var maximum=Math.min(3000,Math.max(300,Math.floor(BAL/10)*10));slider.max=maximum;slider.value=Math.min(maximum,600);}
  var available=ROOT.querySelector('.cash-meta span:last-child b');if(available)available.textContent=rfmNumber(BAL);
  updCash();renderGear();
}
function renderSummary(D){
  var tier=D.tier||'Tier unavailable',points=rfmNumber(D.balance),worth=rfmMoney(D.balance);
  rfmSetText('.snap-tier',D.tier?tier+' Tier':tier);rfmSetText('.snap-pts',points+(D.balance===null?'':' pts'));
  rfmSetText('.snap-worth b',worth);rfmSetText('.pts-chip .tier',D.tier||'—');rfmSetText('.pts-chip b',points);
  rfmSetText('.topbar .chip>div:nth-child(1) .cv',D.tier||'—');rfmSetText('.topbar .chip>div:nth-child(2) .cv',points);
  ROOT.querySelectorAll('.topbar .chip>div:nth-child(3) .cv').forEach(function(e){e.textContent=worth+' in rewards'});
  rfmSetText('[data-rivo-balance-copy]',D.balance===null?'Your current points balance is unavailable.':'Turn '+points+' pts into cash off or free gear.');
  rfmSetText('.rec-note b',D.tier&&D.tierX!==null?D.tier+' '+D.tierX+'×':'your verified tier');
  rfmSetText('.infinity-card:not([data-up]) .t',D.infinityX!==null?D.infinityX+'× Points On The 8th':'Infinity Day multiplier unavailable');
  rfmSetText('[data-rivo-birthday]',D.birthMonth?new Date(2020,D.birthMonth-1,1).toLocaleDateString('en-US',{month:'long'})+' birth month on file':'Not set');
  renderProgress(D);renderTierMarker(D);
}
function configureReferral(D){
  /* RFM_REF_SHARE_V2 — referrers copy their link in place; navigating to your own
     referral URL shows the friend-facing claim popup, which is the wrong audience. */
  RFM_REFERRAL_URL=D&&D.referralUrl?D.referralUrl:null;
  ROOT.querySelectorAll('[data-rivo-referral]').forEach(function(link){
    link.removeAttribute('href');link.removeAttribute('target');link.removeAttribute('rel');
    if(RFM_REFERRAL_URL){
      link.classList.remove('is-disabled');link.removeAttribute('aria-disabled');
      link.innerHTML='Get Your Link <i class="ti ti-arrow-right"></i>';
    } else {
      link.classList.add('is-disabled');link.setAttribute('aria-disabled','true');
      link.textContent='Referral link unavailable';
    }
  });
  var panel=ROOT.querySelector('[data-ref-share]');
  var urlEl=ROOT.querySelector('[data-ref-url]');
  if(panel){panel.hidden=true;}
  if(urlEl&&RFM_REFERRAL_URL){urlEl.textContent=RFM_REFERRAL_URL;}
}
function renderRecommendations(){
  if(RFM_MODE==='demo'){renderRec(REC_DEFAULT);return;}
  if(!RFM)return;
  if(!RFM.orders||!RFM.orders.length){renderRec(REC_FIRST_ORDER);return;}
  if(location.protocol==='file:'){renderRec(REC_DEFAULT);return;}
  var lines=[];RFM.orders.forEach(function(o){(o.items||[]).forEach(function(i){lines.push(i)})});
  if(!lines.length){renderRec(REC_DEFAULT);return;}
  var owned={};lines.forEach(function(i){owned[i.pid]=1});
  var seed=lines.sort(function(a,b){return (b.price||0)-(a.price||0)})[0];
  var cap=Math.max(150,seed.price/100*0.15);
  function accept(p){var v=(p.variants&&p.variants[0])||{},price=(+v.price||0)/100;return !owned[p.id]&&p.product_type!==seed.type&&p.available!==false&&price>0&&price<=cap;}
  function toCard(p){var v=p.variants[0],price=+v.price/100,im=(p.featured_image&&(p.featured_image.src||p.featured_image)||'').replace(/^\/\//,'https://');return {name:p.title.replace(/^RitFit\s+/,''),price:price,from:p.variants.length>1,img:im+(im.indexOf('?')>-1?'&':'?')+'width=280',url:'https://www.ritfitsports.com/products/'+p.handle+'?ref=member-dashboard-rec'};}
  function apply(products){var picks=(products||[]).filter(accept).slice(0,4).map(toCard);if(!picks.length){renderRec(REC_DEFAULT);return;}var names={};picks.forEach(function(p){names[p.name]=1});REC_DEFAULT.forEach(function(p){if(picks.length<4&&!names[p.name])picks.push(p)});renderRec(picks);}
  fetch('/recommendations/products.json?product_id='+seed.pid+'&limit=10&intent=complementary').then(function(r){return r.json()}).then(function(data){if(data.products&&data.products.length){apply(data.products);return;}return fetch('/recommendations/products.json?product_id='+seed.pid+'&limit=10&intent=related').then(function(r){return r.json()}).then(function(next){apply(next.products)});}).catch(function(){renderRec(REC_DEFAULT)});
}
function renderLoyalty(D){
  RFM_LOYALTY=D;TIER_X=D.tierX;renderSummary(D);configureCash(D);configureReferral(D);renderNotices();renderHonestActivity();renderRecommendations();loadShopRewards();refreshCashCta();refreshBdayEdit();
}
function setLoyaltyState(state){
  if(!RFM_SHELL)return;
  RFM_SHELL.classList.remove('rfm-loyalty-loading','rfm-loyalty-error');RFM_SHELL.setAttribute('data-rivo-state',state);
  var status=RFM_SHELL.querySelector('[data-rivo-status]'),title=status&&status.querySelector('[data-rivo-status-title]'),copy=status&&status.querySelector('[data-rivo-status-copy]'),retry=status&&status.querySelector('[data-rivo-retry]');
  if(!status)return;
  status.hidden=state!=='loading'&&state!=='error';retry.hidden=state!=='error';RFM_SHELL.setAttribute('aria-busy',state==='loading'?'true':'false');
  if(state==='loading'){RFM_SHELL.classList.add('rfm-loyalty-loading');title.textContent='Loading your rewards…';copy.textContent='Please wait while we load your current RitFit Rewards details.';}
  if(state==='error'){RFM_SHELL.classList.add('rfm-loyalty-error');title.textContent="We couldn't load your rewards.";copy.textContent='Your account is still safe. Please retry to load your current points and tier.';}
}
function startLoyalty(){
  var token=++RFM_BOOT_TOKEN;
  RFM_RIVO.bootstrap({customer:RFM,location:location,window:window,document:document,timeoutMs:10000,demo:RFM_DEMO,onState:setLoyaltyState})
    .then(function(data){if(token!==RFM_BOOT_TOKEN||!data)return;renderLoyalty(data);setLoyaltyState('ready');})
    .catch(function(){/* setLoyaltyState('error') is emitted by the adapter; never use demo fallback. */});
}
var retryButton=RFM_SHELL&&RFM_SHELL.querySelector('[data-rivo-retry]');if(retryButton)retryButton.addEventListener('click',startLoyalty);
if(!IS_GATED)startLoyalty();

/* deep link: #earn / #redeem / ... */
function viewFromHash(){var h=location.hash.replace('#','');return h&&ROOT.querySelector('#'+'m-view-'+h)?h:'';}
var h0=viewFromHash();
if(h0){go(h0,false);}
window.addEventListener('popstate',function(){go(viewFromHash()||'dashboard',false)});

/* ---- profile interactions ---- */
var fpBody=ROOT.querySelector('#m-fpBody'),fpToggle=ROOT.querySelector('#m-fpToggle');
fpToggle.addEventListener('click',function(){
  var open=fpBody.classList.toggle('open');
  fpToggle.textContent=open?'Close':'Complete It';
});
ROOT.querySelectorAll('.chips .chipbtn').forEach(function(c){
  c.addEventListener('click',function(){
    var wrap=c.parentElement;
    if(wrap.hasAttribute('data-single')){wrap.querySelectorAll('.chipbtn').forEach(function(x){x.classList.remove('on')});c.classList.add('on');}
    else c.classList.toggle('on');
  });
});
/* ---- RFM_REAL_ACTIONS_V1: fitness profile save (Klaviyo) + birthday (RivoJS) ---- */
var FP_STORE_KEY='rfm-fitness-profile-v1';
function fpKlaviyo(){
  var k=window.klaviyo;
  if(k&&typeof k.identify==='function')return {identify:function(p){return Promise.resolve(k.identify(p));}};
  var lq=window._learnq;
  if(lq&&typeof lq.push==='function')return {identify:function(p){lq.push(['identify',p]);return Promise.resolve(true);}};
  return null;
}
function fpCollect(){
  var out={goals:[],experience:'',space:'',shopping:[]};
  if(!fpBody)return out;
  fpBody.querySelectorAll('.fgroup').forEach(function(group){
    var labelEl=group.querySelector('.gl');
    var label=labelEl?labelEl.textContent:'';
    var picked=[].map.call(group.querySelectorAll('.chipbtn.on'),function(chip){return chip.textContent.trim();});
    if(/goals/i.test(label))out.goals=picked;
    else if(/experience/i.test(label))out.experience=picked[0]||'';
    else if(/space/i.test(label))out.space=picked[0]||'';
    else if(/shopping/i.test(label))out.shopping=picked;
  });
  return out;
}
function fpApplySaved(){
  if(RFM_MODE!=='real'||!fpBody)return;
  var saved=null;
  try{saved=JSON.parse(localStorage.getItem(FP_STORE_KEY)||'null');}catch(error){}
  var chips=fpBody.querySelectorAll('.chipbtn');
  chips.forEach(function(chip){chip.classList.remove('on');});
  if(saved&&saved.values){
    var picked={};
    saved.values.forEach(function(value){picked[value]=1;});
    chips.forEach(function(chip){if(picked[chip.textContent.trim()])chip.classList.add('on');});
  }
  if(!saved&&!window.RFM_FITNESS_DONE)return;
  if(fpSave)fpSave.disabled=true;
  fpShowNote('Fitness profile completed. Your +100 points reward is secured.',false);
}
var fpSave=ROOT.querySelector('[data-fp-save]');
var fpNote=ROOT.querySelector('[data-fp-note]');
function fpShowNote(text,isError){
  if(!fpNote)return;
  fpNote.hidden=false;fpNote.textContent=text;fpNote.classList.toggle('err',!!isError);
}
if(fpSave)fpSave.addEventListener('click',function(){
  if(RFM_MODE!=='real'){fpShowNote('Demo preview — profile saving is disabled.',true);return;}
  if(!RFM||!RFM.email){fpShowNote('We could not confirm your account email. Please refresh and try again.',true);return;}
  var channel=fpKlaviyo();
  if(!channel){fpShowNote('Profile saving is temporarily unavailable. Please try again later.',true);return;}
  var data=fpCollect();
  if(!data.goals.length&&!data.experience&&!data.space&&!data.shopping.length){fpShowNote('Pick at least one option first.',true);return;}
  fpSave.disabled=true;
  var savedAt=new Date().toISOString();
  channel.identify({
    '$email':RFM.email,
    'rfm_fitness_goals':data.goals.join(', '),
    'rfm_experience_level':data.experience,
    'rfm_training_space':data.space,
    'rfm_shopping_for':data.shopping.join(', '),
    'rfm_fitness_profile_saved_at':savedAt
  }).then(function(){
    try{
      localStorage.setItem(FP_STORE_KEY,JSON.stringify({
        values:[].concat(data.goals,[data.experience],[data.space],data.shopping).filter(Boolean),
        saved_at:savedAt
      }));
    }catch(error){}
    fpSave.disabled=true;
    fpShowNote('Saved! Your +100 points reward will be added shortly.',false);refreshFitnessMove();
  }).catch(function(){
    fpSave.disabled=false;
    fpShowNote('We could not save your profile. Please try again.',true);
  });
});
fpApplySaved();
function refreshFitnessMove(){
  var card=ROOT.querySelector('[data-move="fitness"]'); if(!card)return;
  var saved=null;
  try{saved=JSON.parse(localStorage.getItem(FP_STORE_KEY)||'null');}catch(error){}
  var localDone=!!(saved&&saved.values&&saved.values.length);
  card.hidden=RFM_MODE==='real'&&(localDone||!!window.RFM_FITNESS_DONE);
}
refreshFitnessMove();
var bdaySave=ROOT.querySelector('[data-bday-save]');
var bdayNote=ROOT.querySelector('[data-bday-note]');
function bdayShowNote(text,isError){
  if(!bdayNote)return;
  bdayNote.hidden=false;bdayNote.textContent=text;bdayNote.classList.toggle('err',!!isError);
}
function refreshBdayEdit(){
  var row=ROOT.querySelector('[data-bday-edit]'); if(!row)return;
  var api=window.RivoJS;
  var usable=RFM_MODE==='real'&&api&&typeof api.updateCustomerDob==='function';
  row.hidden=!(usable&&RFM_LOYALTY&&RFM_LOYALTY.birthMonth===null);
}
if(bdaySave)bdaySave.addEventListener('click',function(){
  if(RFM_MODE!=='real'){bdayShowNote('Demo preview — saving is disabled.',true);return;}
  var input=ROOT.querySelector('[data-bday-input]');
  var value=input&&input.value;
  if(!value){bdayShowNote('Pick your birth date first.',true);return;}
  var parsed=new Date(value+'T00:00:00Z');
  var age=(Date.now()-parsed.getTime())/31557600000;
  if(!Number.isFinite(parsed.getTime())||age<13||age>120){bdayShowNote('Please enter a valid birth date.',true);return;}
  var api=window.RivoJS;
  if(!api||typeof api.updateCustomerDob!=='function'){bdayShowNote('Birthday updates are temporarily unavailable.',true);return;}
  bdaySave.disabled=true;
  Promise.resolve(api.updateCustomerDob(value)).then(function(ok){
    if(ok===false)throw new Error('rejected');
    /* mirror to Klaviyo so the birthday flow can trigger (Rivo's own property sync does not fire for storefront DOB writes; 1940 = legacy year placeholder) */
    try{var bdCh=fpKlaviyo();if(bdCh&&RFM&&RFM.email){var bdMirror='1940-'+value.slice(5);bdCh.identify({'$email':RFM.email,'Rivo Date of Birth':bdMirror,'rfm_dob':bdMirror});}}catch(mirrorErr){}
    bdayShowNote('Birthday saved! Your birthday rewards will use this date.',false);
    var row=ROOT.querySelector('[data-bday-edit]');
    if(row)row.hidden=true;
    refreshLoyaltyAfterRedeem();
  }).catch(function(){
    bdaySave.disabled=false;
    bdayShowNote('We could not save your birthday. It may already be set on your account.',true);
  });
});
refreshBdayEdit();

/* ---- addresses view (embedded 2026-07-23) ---- */
var ADDR=window.RFM_ADDRESSES||null;
var ADDR_DEMO=[
  {id:1,firstName:'Alex',lastName:'Rivera',company:'',address1:'2500 Summer St',address2:'Apt 12',city:'Houston',province:'Texas',provinceCode:'TX',country:'United States',countryCode:'US',zip:'77007',phone:'(713) 555-0142'},
  {id:2,firstName:'Alex',lastName:'Rivera',company:'RitFit Home Gym',address1:'88 Congress Ave',address2:'',city:'Austin',province:'Texas',provinceCode:'TX',country:'United States',countryCode:'US',zip:'78701',phone:''}
];
function addrEsc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]});}
(function(){
  var host=ROOT.querySelector('#m-addrList'); if(!host) return;
  var isDemo=!ADDR&&RFM_MODE==='demo';
  var items=ADDR?(ADDR.items||[]):(isDemo?ADDR_DEMO:[]);
  var defaultId=ADDR?ADDR.defaultId:(isDemo?1:null);
  items=items.slice().sort(function(a,b){return (String(b.id)===String(defaultId)?1:0)-(String(a.id)===String(defaultId)?1:0);});
  var wrap=ROOT.querySelector('#m-addrFormWrap');
  var formTitle=ROOT.querySelector('#m-addrFormTitle');
  var form=ROOT.querySelector('#m-addrForm');
  var addBtn=ROOT.querySelector('#m-addrAddBtn');
  var listNoteEl=ROOT.querySelector('#m-addrListNote');
  var countrySel=form?form.querySelector('[data-addr-country]'):null;
  var provinceSel=form?form.querySelector('[data-addr-province]'):null;
  var provinceWrap=form?form.querySelector('[data-addr-province-wrap]'):null;
  var methodInp=form?form.querySelector('[data-addr-method]'):null;
  var noteEl=form?form.querySelector('[data-addr-note]'):null;
  var busy=false;

  function listNote(msg,err){if(!listNoteEl)return;listNoteEl.hidden=false;listNoteEl.textContent=msg;listNoteEl.style.color=err?'#b3261e':'';}
  function note(msg,err){if(!noteEl)return;noteEl.hidden=false;noteEl.textContent=msg;noteEl.style.color=err?'#b3261e':'';}
  function provinceData(){
    if(!countrySel||countrySel.selectedIndex<0)return[];
    var opt=countrySel.options[countrySel.selectedIndex]; if(!opt)return[];
    var raw=opt.getAttribute('data-provinces'); if(!raw)return[];
    try{return JSON.parse(raw)||[]}catch(e){return[]}
  }
  function syncProvinces(want){
    if(!provinceSel)return;
    var provs=provinceData();
    provinceSel.innerHTML='';
    if(!provs.length){if(provinceWrap)provinceWrap.hidden=true;provinceSel.disabled=true;return;}
    if(provinceWrap)provinceWrap.hidden=false;provinceSel.disabled=false;
    provs.forEach(function(p){var o=document.createElement('option');o.value=p[0];o.textContent=p[1];provinceSel.appendChild(o);});
    if(want){
      provinceSel.value=want;
      if(provinceSel.value!==want){for(var i=0;i<provinceSel.options.length;i++){if(provinceSel.options[i].textContent===want){provinceSel.selectedIndex=i;break;}}}
    }
  }
  function setF(n,v){var el=form.elements['address['+n+']'];if(el)el.value=v==null?'':v;}
  function openForm(mode,a){
    if(!form||!wrap)return;
    form.reset();
    if(noteEl){noteEl.hidden=true;noteEl.textContent='';}
    setF('first_name',a&&a.firstName);setF('last_name',a&&a.lastName);setF('company',a&&a.company);
    setF('address1',a&&a.address1);setF('address2',a&&a.address2);setF('city',a&&a.city);
    setF('zip',a&&a.zip);setF('phone',a&&a.phone);
    if(countrySel){
      countrySel.value=(a&&a.country)||'United States';
      if(countrySel.selectedIndex<0&&countrySel.options.length)countrySel.selectedIndex=0;
    }
    syncProvinces(a?(a.provinceCode||a.province||''):'');
    var dflt=form.querySelector('[data-addr-default]');
    if(dflt)dflt.checked=a?String(a.id)===String(defaultId):false;
    if(mode==='edit'&&a){form.action='/account/addresses/'+a.id;if(methodInp)methodInp.disabled=false;}
    else{form.action='/account/addresses';if(methodInp)methodInp.disabled=true;}
    if(formTitle)formTitle.textContent=mode==='edit'?'Edit address':'Add a new address';
    wrap.hidden=false;
    var sb=form.querySelector('[data-addr-submit]'); if(sb)sb.disabled=false;
    if(wrap.scrollIntoView)wrap.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  function closeForm(){if(wrap)wrap.hidden=true;}
  function fmtLines(a){
    var l1=[a.address1,a.address2].filter(Boolean).join(', ');
    var l2=[a.city,(a.provinceCode||a.province),a.zip].filter(Boolean).join(', ');
    return [l1,l2,a.country].filter(Boolean);
  }
  function render(){
    if(!items.length){host.innerHTML='<div class="addr-empty">No addresses saved yet — add your first shipping address below.</div>';return;}
    host.innerHTML=items.map(function(a){
      var isD=String(a.id)===String(defaultId);
      var name=addrEsc([a.firstName,a.lastName].filter(Boolean).join(' '))||'—';
      var lines=fmtLines(a).map(function(x){return '<div class="addr-line">'+addrEsc(x)+'</div>'}).join('');
      var comp=a.company?'<div class="addr-line addr-co">'+addrEsc(a.company)+'</div>':'';
      var phone=a.phone?'<div class="addr-line addr-phone">'+addrEsc(a.phone)+'</div>':'';
      return '<div class="addr-card">'
        +(isD?'<span class="addr-badge">Default</span>':'')
        +'<div class="addr-name">'+name+'</div>'+comp+lines+phone
        +'<div class="addr-ops">'
        +'<button class="addr-op" type="button" data-addr-edit="'+addrEsc(a.id)+'">Edit</button>'
        +'<button class="addr-op addr-del" type="button" data-addr-rm="'+addrEsc(a.id)+'">Delete</button>'
        +(isD?'':'<button class="addr-op" type="button" data-addr-mkdef="'+addrEsc(a.id)+'">Set as default</button>')
        +'</div></div>';
    }).join('');
  }
  function byId(id){return items.filter(function(x){return String(x.id)===String(id)})[0]||null;}
  function postAddr(url,fd,btn){
    if(busy)return;busy=true;if(btn)btn.disabled=true;
    fetch(url,{method:'POST',body:fd,credentials:'same-origin',redirect:'follow'}).then(function(r){
      if(r.ok&&r.redirected){location.reload();return;}
      busy=false;if(btn)btn.disabled=false;
      var msg=r.ok?'Couldn\'t save — please check the required fields and try again.':'Something went wrong ('+r.status+'). Please try again.';
      note(msg,true);listNote(msg,true);
    }).catch(function(){
      busy=false;if(btn)btn.disabled=false;
      note('Network error — please try again.',true);listNote('Network error — please try again.',true);
    });
  }
  function delAddr(id){
    if(isDemo){listNote('Demo preview — address changes are disabled here.');return;}
    if(!window.confirm('Delete this address?'))return;
    var fd=new FormData();fd.append('_method','delete');
    postAddr('/account/addresses/'+id,fd,null);
  }
  function mkDefault(id){
    if(isDemo){listNote('Demo preview — address changes are disabled here.');return;}
    var a=byId(id); if(!a)return;
    var fd=new FormData();
    fd.append('form_type','customer_address');fd.append('utf8','✓');fd.append('_method','put');
    [['first_name',a.firstName],['last_name',a.lastName],['company',a.company],['address1',a.address1],['address2',a.address2],['city',a.city],['province',a.provinceCode||a.province],['country',a.country],['zip',a.zip],['phone',a.phone]].forEach(function(p){fd.append('address['+p[0]+']',p[1]==null?'':p[1]);});
    fd.append('address[default]','1');
    postAddr('/account/addresses/'+id,fd,null);
  }
  if(addBtn)addBtn.addEventListener('click',function(){openForm('new',null);});
  host.addEventListener('click',function(e){
    var t=e.target&&e.target.closest?e.target.closest('button.addr-op'):null; if(!t)return;
    if(t.hasAttribute('data-addr-edit')){var a=byId(t.getAttribute('data-addr-edit'));if(a)openForm('edit',a);}
    else if(t.hasAttribute('data-addr-rm')){delAddr(t.getAttribute('data-addr-rm'));}
    else if(t.hasAttribute('data-addr-mkdef')){mkDefault(t.getAttribute('data-addr-mkdef'));}
  });
  if(countrySel)countrySel.addEventListener('change',function(){syncProvinces('');});
  if(form)form.addEventListener('submit',function(e){
    e.preventDefault();
    if(isDemo){note('Demo preview — saving is disabled here.',true);return;}
    var sb=form.querySelector('[data-addr-submit]');
    postAddr(form.getAttribute('action'),new FormData(form),sb);
  });
  var cancelBtn=form?form.querySelector('[data-addr-cancel]'):null;
  if(cancelBtn)cancelBtn.addEventListener('click',closeForm);
  render();
})();

/* smart store link: Android UA → Google Play, everyone else → App Store */
(function(){
  var link=ROOT.querySelector('[data-app-link]'); if(!link) return;
  if(/android/i.test(navigator.userAgent))link.href='https://play.google.com/store/apps/details?id=com.ritfitsports.ritfit';
})();

/* survey gate: hide every survey entry for customers already tagged 'Survey'
   (tag maintained by the survey owner; Liquid-computed, see RFM_SURVEY_DONE) */
(function(){
  if(window.RFM_SURVEY_DONE!==true) return;
  ROOT.querySelectorAll('[data-survey-entry]').forEach(function(el){el.hidden=true;el.style.display='none';});
})();

})();
